// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Instrument+Serif:ital@0;1&family=Manrope:wght@500;600&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.corner-label {
  position: absolute;
  z-index: 20;
  font-family: "DM Mono", monospace;
  font-size: 17px;
  letter-spacing: 0.16em;
  line-height: 1;
  text-transform: uppercase;
}

.top-left {
  top: 50px;
  left: 62px;
}

.top-right {
  top: 50px;
  right: 62px;
}

.bottom-left {
  bottom: 50px;
  left: 62px;
}

.bottom-right {
  right: 62px;
  bottom: 50px;
}

.orbit-dot {
  position: absolute;
  top: 50%;
  left: -13px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #ff5c35;
  transform: translateY(-50%);
}

.orbit-dot.small {
  left: auto;
  right: -10px;
  width: 20px;
  height: 20px;
  background: #4d64ff;
}

.intro-copy {
  position: absolute;
  top: 190px;
  right: 100px;
  width: 960px;
}

.eyebrow {
  margin-bottom: 54px;
  font-family: "DM Mono", monospace;
  font-size: 19px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.intro-copy h1,
.final-copy h2 {
  margin: 0 0 56px;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 150px;
  font-weight: 400;
  line-height: 0.84;
  letter-spacing: -0.045em;
}

.intro-copy h1 em,
.final-copy h2 em {
  color: #4d64ff;
  font-weight: 400;
}

.word-stack {
  position: absolute;
  inset: 130px 80px;
  display: grid;
  gap: 15px;
}

.word-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 255px;
  padding: 10px 54px 25px;
  overflow: hidden;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 210px;
  line-height: 1;
  letter-spacing: -0.045em;
}

.word-index {
  align-self: flex-start;
  margin-top: 28px;
  font-family: "DM Mono", monospace;
  font-size: 19px;
  letter-spacing: 0.1em;
}

.system-title {
  position: absolute;
  top: 140px;
  left: 100px;
}

.system-title span {
  font-family: "DM Mono", monospace;
  font-size: 18px;
  letter-spacing: 0.14em;
}

.system-title h2 {
  width: 1020px;
  margin: 34px 0 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 112px;
  font-weight: 400;
  line-height: 0.92;
  letter-spacing: -0.04em;
}

.metric-grid {
  position: absolute;
  right: 100px;
  bottom: 125px;
  left: 100px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.metric {
  height: 335px;
  padding: 34px;
  color: #0a0a0a;
}

.metric-label {
  font-family: "DM Mono", monospace;
  font-size: 17px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.metric-value {
  margin-top: 118px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 48px;
  font-weight: 600;
  letter-spacing: -0.045em;
}

.metric-line {
  height: 3px;
  margin-top: 28px;
  background: rgba(10, 10, 10, 0.2);
}

.metric-line > div {
  width: 100%;
  height: 100%;
  background: #0a0a0a;
  transform-origin: left center;
}

.final-accent {
  position: absolute;
  top: -260px;
  right: -220px;
  width: 850px;
  height: 1500px;
  background: #d9ff43;
}

.final-copy {
  position: absolute;
  top: 205px;
  left: 105px;
  width: 1250px;
}

.eyebrow.light {
  color: #a8a8a0;
}

.final-copy h2 {
  color: #f0eee7;
  font-size: 160px;
}

.final-copy h2 em {
  color: #d9ff43;
}

.final-rule {
  width: 780px;
  height: 3px;
  background: #f0eee7;
  transform-origin: left center;
}

/* PremiumMotion */
.pm-camera {
  position: absolute;
  inset: 0;
  transform-origin: center;
}

.pm-tech {
  position: absolute;
  z-index: 40;
  inset: 0;
  font-family: "DM Mono", monospace;
  font-size: 16px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  pointer-events: none;
}

.pm-tech span {
  position: absolute;
}

.pm-tech-tl {
  top: 46px;
  left: 58px;
}

.pm-tech-tr {
  top: 46px;
  right: 58px;
}

.pm-tech-bl {
  bottom: 46px;
  left: 58px;
}

.pm-tech-br {
  right: 58px;
  bottom: 46px;
}

.pm-precision-camera {
  top: 155px;
  right: 110px;
  bottom: auto;
  left: 110px;
}

.pm-precision-kicker,
.pm-focus-copy > span,
.pm-final-copy > span {
  font-family: "DM Mono", monospace;
  font-size: 18px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.pm-precision-title {
  position: relative;
  z-index: 2;
  margin: 72px 0 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 205px;
  font-weight: 400;
  line-height: 0.78;
  letter-spacing: -0.055em;
}

.pm-chromatic {
  position: relative;
  display: block;
  isolation: isolate;
}

.pm-chromatic-base,
.pm-chromatic-color {
  display: block;
}

.pm-chromatic-base {
  position: relative;
  z-index: 3;
}

.pm-chromatic-color {
  position: absolute;
  inset: 0;
  opacity: 0.78;
  mix-blend-mode: screen;
}

.pm-chromatic-blue {
  z-index: 1;
  color: #3155ff;
}

.pm-chromatic-red {
  z-index: 2;
  color: #ff4f38;
}

.pm-precision-italic {
  display: block;
  padding-left: 390px;
  color: #d8ff3e;
  font-style: italic;
}

.pm-rule {
  width: 1170px;
  height: 3px;
  margin-top: 90px;
  background: rgba(243, 240, 232, 0.18);
}

.pm-rule > div {
  width: 100%;
  height: 100%;
  background: #f3f0e8;
  transform-origin: left center;
}

.pm-color-orb {
  position: absolute;
  width: 620px;
  height: 620px;
  border-radius: 50%;
  filter: blur(110px);
  mix-blend-mode: screen;
}

.pm-orb-blue {
  right: -130px;
  bottom: -220px;
  background: #3155ff;
}

.pm-orb-red {
  top: -280px;
  right: 360px;
  background: #ff4f38;
}

.pm-aperture-camera {
  display: grid;
  place-items: center;
  transform-origin: 47% 50%;
}

.pm-aperture {
  width: 780px;
  height: 780px;
}

.pm-focus-copy {
  position: absolute;
  z-index: 5;
  top: 250px;
  right: 120px;
  width: 760px;
}

.pm-focus-copy h2,
.pm-final-copy h2 {
  margin: 50px 0 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 118px;
  font-weight: 400;
  line-height: 0.9;
  letter-spacing: -0.045em;
}

.pm-focus-copy h2 em {
  color: #3155ff;
  font-weight: 400;
}

.pm-ribbon {
  position: absolute;
  left: -300px;
  display: flex;
  align-items: center;
  gap: 90px;
  width: 2550px;
  height: 215px;
  padding: 0 36px 18px;
  overflow: hidden;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 155px;
  line-height: 1;
  letter-spacing: -0.045em;
  white-space: nowrap;
  transform-origin: center;
}

.pm-flow-caption {
  position: absolute;
  z-index: 20;
  right: 76px;
  bottom: 72px;
  font-family: "DM Mono", monospace;
  font-size: 18px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.pm-final-camera {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: 100px;
  align-items: center;
  padding: 120px 105px;
}

.pm-final-copy {
  position: relative;
  z-index: 3;
}

.pm-final-copy h2 {
  font-size: 135px;
}

.pm-final-copy h2 em {
  color: #d8ff3e;
  font-weight: 400;
}

.pm-bezier-wrap {
  position: relative;
  z-index: 3;
}

.pm-bezier {
  width: 720px;
}

.pm-curve-label {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  font-family: "DM Mono", monospace;
  font-size: 16px;
  letter-spacing: 0.12em;
}

.pm-curve-label span {
  color: #9f9d97;
}

.pm-final-flood {
  position: absolute;
  z-index: 2;
  inset: 0;
  background: #d8ff3e;
  transform-origin: left center;
}

/* TableJourney */
.tj-world {
  position: absolute;
  top: 0;
  left: 0;
  width: 5200px;
  height: 3400px;
  color: #11100e;
  background: #eae6dd;
  transform-origin: 960px 540px;
}

.tj-grid {
  position: absolute;
  inset: 0;
  opacity: 0.3;
  background-image:
    linear-gradient(rgba(17, 16, 14, 0.12) 1px, transparent 1px),
    linear-gradient(90deg, rgba(17, 16, 14, 0.12) 1px, transparent 1px);
  background-size: 80px 80px;
}

.tj-world-label {
  position: absolute;
  top: 70px;
  left: 70px;
  font-family: "DM Mono", monospace;
  font-size: 15px;
  letter-spacing: 0.14em;
}

.tj-group {
  position: absolute;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}

.tj-type-group {
  top: 0;
  left: 0;
}

.tj-material-group {
  top: -100px;
  left: 2200px;
}

.tj-icon-group {
  top: 1350px;
  left: 2200px;
}

.tj-finale-group {
  top: 1450px;
  left: 0;
  color: #f8f5ed;
  background: #11100e;
}

.tj-group-index {
  position: absolute;
  top: 86px;
  left: 100px;
  font-family: "DM Mono", monospace;
  font-size: 17px;
  letter-spacing: 0.14em;
}

.tj-type-stage {
  position: absolute;
  top: 260px;
  left: 105px;
}

.tj-type-line {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 172px;
  line-height: 0.86;
  letter-spacing: -0.055em;
  white-space: nowrap;
}

.tj-type-line-two {
  margin-left: 305px;
  color: #4f63ff;
  font-style: italic;
}

.tj-type-mask {
  width: 1220px;
  height: 24px;
  margin-top: 82px;
  background: #11100e;
  transform-origin: left center;
}

.tj-note {
  position: absolute;
  display: grid;
  grid-template-columns: 50px 1fr;
  gap: 18px;
  align-items: center;
  font-family: "DM Mono", monospace;
  font-size: 17px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.tj-note span {
  display: grid;
  width: 50px;
  height: 50px;
  color: #11100e;
  border: 1px solid #11100e;
  border-radius: 50%;
  place-items: center;
}

.tj-note-a {
  right: 130px;
  bottom: 130px;
}

.tj-orbit {
  position: absolute;
  top: 170px;
  right: 180px;
  width: 240px;
  height: 240px;
  border: 2px solid #11100e;
  border-radius: 50%;
}

.tj-orbit div {
  position: absolute;
  top: 50%;
  left: -15px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #cfff38;
  transform: translateY(-50%);
}

.tj-material-title,
.tj-icon-title {
  position: absolute;
  top: 145px;
  left: 100px;
  margin: 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 112px;
  font-weight: 400;
  line-height: 0.9;
  letter-spacing: -0.045em;
}

.tj-material-title em,
.tj-icon-title em {
  color: #4f63ff;
  font-weight: 400;
}

.tj-material-cards {
  position: absolute;
  right: 110px;
  bottom: 115px;
  left: 110px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.tj-material-card {
  position: relative;
  height: 400px;
  padding: 34px;
  box-shadow: 0 26px 55px rgba(17, 16, 14, 0.13);
}

.tj-material-card span {
  font-family: "DM Mono", monospace;
  font-size: 16px;
}

.tj-material-card strong {
  position: absolute;
  bottom: 55px;
  left: 34px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 49px;
  letter-spacing: -0.04em;
}

.tj-card-rule {
  position: absolute;
  right: 34px;
  bottom: 35px;
  left: 34px;
  height: 3px;
  background: #11100e;
}

.tj-lens {
  position: absolute;
  z-index: 5;
  top: 130px;
  right: 310px;
  width: 330px;
  height: 330px;
  border: 3px solid #11100e;
  border-radius: 50%;
  background: rgba(255, 104, 181, 0.42);
  backdrop-filter: blur(7px);
  mix-blend-mode: multiply;
}

.tj-icon-title {
  top: 155px;
}

.tj-icon-title em {
  color: #ff6846;
}

.tj-icon-row {
  position: absolute;
  right: 110px;
  bottom: 150px;
  left: 110px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
}

.tj-icon-tile {
  display: grid;
  height: 390px;
  padding: 30px;
  border: 2px solid #11100e;
  place-items: center;
}

.tj-icon-tile svg {
  width: 260px;
  height: 260px;
}

.tj-icon-tile span {
  font-family: "DM Mono", monospace;
  font-size: 16px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.tj-connection-line {
  position: absolute;
  right: 110px;
  bottom: 105px;
  left: 110px;
  height: 3px;
  background: rgba(17, 16, 14, 0.2);
}

.tj-connection-line div {
  width: 100%;
  height: 100%;
  background: #11100e;
  transform-origin: left center;
}

.tj-final-words {
  position: absolute;
  top: 300px;
  left: 100px;
  display: flex;
  overflow: hidden;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 230px;
  line-height: 1;
  letter-spacing: -0.065em;
}

.tj-final-words span {
  display: inline-block;
}

.tj-final-copy {
  position: absolute;
  bottom: 150px;
  left: 110px;
  margin: 0;
  font-family: "DM Mono", monospace;
  font-size: 19px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.tj-final-circle {
  position: absolute;
  top: 50%;
  right: 75px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: #4f63ff;
  mix-blend-mode: screen;
}

.tj-corner-data {
  position: absolute;
  z-index: 50;
  inset: 0;
  color: #f8f5ed;
  font-family: "DM Mono", monospace;
  font-size: 15px;
  letter-spacing: 0.12em;
  pointer-events: none;
  mix-blend-mode: difference;
}

.tj-corner-data span {
  position: absolute;
}

.tj-corner-data span:nth-child(1) {
  top: 44px;
  left: 54px;
}

.tj-corner-data span:nth-child(2) {
  top: 44px;
  right: 54px;
}

.tj-corner-data span:nth-child(3) {
  bottom: 44px;
  left: 54px;
}

.tj-morph-cursor {
  position: absolute;
  z-index: 45;
  top: 50%;
  left: 50%;
  box-shadow: 0 8px 28px rgba(17, 16, 14, 0.2);
  pointer-events: none;
  mix-blend-mode: difference;
}

.tj-parallax {
  position: absolute;
  z-index: 30;
  inset: -15%;
  pointer-events: none;
}

.tj-parallax i {
  position: absolute;
  display: block;
  border-radius: 50%;
  opacity: 0.5;
  mix-blend-mode: difference;
}

.tj-vignette {
  position: absolute;
  z-index: 44;
  inset: 0;
  box-shadow: inset 0 0 180px rgba(0, 0, 0, 0.3);
  pointer-events: none;
}

/* GlassHudJourney */
.gh-world {
  position: absolute;
  top: 0;
  left: 0;
  width: 4140px;
  height: 3600px;
  color: #f7f8ff;
  background: #050816;
  transform-origin: 960px 540px;
}

.gh-world-grid {
  position: absolute;
  inset: 0;
  opacity: 0.16;
  background-image:
    linear-gradient(rgba(98, 231, 255, 0.2) 1px, transparent 1px),
    linear-gradient(90deg, rgba(98, 231, 255, 0.2) 1px, transparent 1px);
  background-size: 72px 72px;
}

.gh-aurora {
  position: absolute;
  width: 1200px;
  height: 1200px;
  border-radius: 50%;
  filter: blur(210px);
  opacity: 0.34;
}

.gh-aurora-a {
  top: -430px;
  left: 530px;
  background: #5269ff;
}

.gh-aurora-b {
  right: 150px;
  bottom: -380px;
  background: #ff65bf;
}

.gh-station {
  position: absolute;
  width: 1920px;
  height: 1080px;
  overflow: hidden;
}

.gh-photo-plate {
  position: absolute;
  z-index: 0;
  inset: 0;
  overflow: hidden;
}

.gh-photo-grade {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 68% 42%, transparent 0%, rgba(5, 8, 22, 0.18) 42%, rgba(5, 8, 22, 0.76) 100%),
    linear-gradient(90deg, rgba(5, 8, 22, 0.7), rgba(5, 8, 22, 0.08) 55%, rgba(5, 8, 22, 0.48));
}

.gh-intro {
  top: 0;
  left: 0;
}

.gh-system {
  top: 0;
  left: 2120px;
}

.gh-waves {
  top: 1260px;
  left: 2120px;
}

.gh-finale {
  top: 1260px;
  left: 0;
}

.gh-design-lab {
  top: 2520px;
  left: 0;
}

.gh-station-label {
  position: absolute;
  z-index: 8;
  top: 76px;
  left: 86px;
  color: rgba(247, 248, 255, 0.64);
  font-family: "DM Mono", monospace;
  font-size: 16px;
  letter-spacing: 0.16em;
}

.gh-glass {
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.055));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.34),
    0 30px 80px rgba(0, 0, 0, 0.26);
  backdrop-filter: blur(28px) saturate(1.3);
}

.gh-intro-copy {
  position: absolute;
  z-index: 5;
  top: 230px;
  left: 92px;
  width: 1040px;
}

.gh-intro-copy > span,
.gh-wave-copy > span,
.gh-final-copy > span {
  font-family: "DM Mono", monospace;
  font-size: 17px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.gh-intro-copy h1,
.gh-system-title,
.gh-wave-copy h2,
.gh-final-copy h2 {
  margin: 44px 0 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 112px;
  font-weight: 500;
  line-height: 0.94;
  letter-spacing: -0.06em;
}

.gh-intro-copy h1 em,
.gh-system-title em,
.gh-wave-copy h2 em,
.gh-final-copy h2 em {
  color: #62e7ff;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 1.18em;
  font-weight: 400;
}

.gh-radar-card {
  position: absolute;
  z-index: 6;
  top: 168px;
  right: 100px;
  width: 520px;
  height: 690px;
  padding: 32px;
  overflow: hidden;
  border-radius: 54px;
}

.gh-card-head,
.gh-card-foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgba(247, 248, 255, 0.72);
  font-family: "DM Mono", monospace;
  font-size: 14px;
  letter-spacing: 0.12em;
}

.gh-card-head i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #c8ff62;
  box-shadow: 0 0 18px #c8ff62;
}

.gh-radar {
  width: 100%;
  margin-top: 55px;
  color: #62e7ff;
}

.gh-card-foot {
  margin-top: 55px;
}

.gh-mini-hud {
  position: absolute;
  z-index: 6;
  right: 150px;
  bottom: 86px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px 40px;
  width: 420px;
  padding: 22px 26px;
  border-radius: 24px;
  font-family: "DM Mono", monospace;
  font-size: 14px;
}

.gh-mini-hud strong {
  color: #c8ff62;
  font-size: 20px;
}

.gh-mini-hud > div {
  grid-column: 1 / -1;
  height: 5px;
  overflow: hidden;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.12);
}

.gh-mini-hud i {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #5269ff, #62e7ff, #c8ff62);
  transform-origin: left center;
}

.gh-scan-light {
  position: absolute;
  z-index: 4;
  top: -250px;
  left: 610px;
  width: 240px;
  height: 1550px;
  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.3), rgba(255, 255, 255, 0.42), transparent);
  filter: blur(28px);
  mix-blend-mode: screen;
}

.gh-system-title {
  position: absolute;
  top: 150px;
  left: 92px;
  margin: 0;
}

.gh-system-title em {
  color: #ff65bf;
}

.gh-module-grid {
  position: absolute;
  right: 90px;
  bottom: 150px;
  left: 90px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 26px;
  perspective: 1200px;
}

.gh-module {
  position: relative;
  height: 425px;
  padding: 34px;
  overflow: hidden;
  border-radius: 46px;
}

.gh-module-icon {
  display: grid;
  width: 82px;
  height: 82px;
  border: 1px solid currentColor;
  border-radius: 26px;
  place-items: center;
}

.gh-module-icon svg,
.gh-module-arrow svg {
  width: 42px;
  height: 42px;
}

.gh-module > span {
  position: absolute;
  bottom: 125px;
  color: rgba(247, 248, 255, 0.56);
  font-family: "DM Mono", monospace;
  font-size: 14px;
  letter-spacing: 0.12em;
}

.gh-module h3 {
  position: absolute;
  bottom: 50px;
  margin: 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 48px;
  font-weight: 500;
  letter-spacing: -0.045em;
}

.gh-module-arrow {
  position: absolute;
  right: 34px;
  bottom: 34px;
  color: rgba(247, 248, 255, 0.65);
}

.gh-glass-shine {
  position: absolute;
  top: -150px;
  left: -240px;
  width: 160px;
  height: 750px;
  background: rgba(255, 255, 255, 0.35);
  filter: blur(24px);
}

.gh-dock {
  position: absolute;
  z-index: 8;
  bottom: 60px;
  left: 50%;
  display: flex;
  gap: 12px;
  padding: 12px;
  border-radius: 28px;
  transform: translateX(-50%);
}

.gh-dock span {
  display: grid;
  width: 58px;
  height: 58px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.08);
  font-family: "Manrope", Arial, sans-serif;
  font-size: 23px;
  place-items: center;
}

.gh-wave-field {
  position: absolute;
  top: 210px;
  left: 230px;
  width: 1500px;
  height: 620px;
}

.gh-wave-copy {
  position: absolute;
  z-index: 6;
  top: 280px;
  left: 135px;
  width: 710px;
  padding: 48px;
  border-radius: 48px;
}

.gh-wave-copy h2 {
  font-size: 94px;
}

.gh-wave-copy h2 em {
  color: #ff65bf;
}

.gh-flight-arrow {
  position: absolute;
  z-index: 8;
  top: 260px;
  left: 950px;
  display: grid;
  width: 110px;
  height: 110px;
  color: #050816;
  border-radius: 35px;
  background: #c8ff62;
  box-shadow: 0 0 50px rgba(200, 255, 98, 0.45);
  place-items: center;
}

.gh-flight-arrow svg {
  width: 62px;
}

.gh-wave-data {
  position: absolute;
  right: 100px;
  bottom: 90px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 14px 34px;
  padding: 25px 30px;
  color: rgba(247, 248, 255, 0.68);
  font-family: "DM Mono", monospace;
  font-size: 14px;
  border-left: 2px solid #62e7ff;
}

.gh-wave-data strong {
  color: #f7f8ff;
  font-weight: 400;
}

.gh-final-copy {
  position: absolute;
  z-index: 6;
  top: 230px;
  left: 110px;
}

.gh-final-copy h2 {
  font-size: 136px;
}

.gh-final-copy h2 em {
  color: #c8ff62;
}

.gh-final-light {
  position: absolute;
  top: -580px;
  left: 600px;
  width: 480px;
  height: 2200px;
  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.18), rgba(255, 255, 255, 0.4), transparent);
  filter: blur(45px);
  mix-blend-mode: screen;
}

.gh-final-pills {
  position: absolute;
  z-index: 7;
  right: 100px;
  bottom: 100px;
  display: flex;
  gap: 14px;
}

.gh-final-pills span {
  min-width: 160px;
  padding: 20px 26px;
  border-radius: 999px;
  font-family: "DM Mono", monospace;
  font-size: 14px;
  letter-spacing: 0.14em;
  text-align: center;
}

.gh-swipe {
  position: absolute;
  z-index: 5;
  inset: 0;
  background: linear-gradient(100deg, #5269ff 0%, #9c6cff 45%, #ff65bf 100%);
  transform-origin: left center;
  mix-blend-mode: screen;
}

.gh-screen-hud {
  position: absolute;
  z-index: 50;
  inset: 0;
  color: rgba(247, 248, 255, 0.72);
  font-family: "DM Mono", monospace;
  font-size: 14px;
  letter-spacing: 0.14em;
  pointer-events: none;
}

.gh-screen-top,
.gh-screen-bottom {
  position: absolute;
  right: 46px;
  left: 46px;
  display: flex;
  justify-content: space-between;
}

.gh-screen-top {
  top: 34px;
}

.gh-screen-bottom {
  bottom: 34px;
}

.gh-screen-bottom span:first-child {
  color: #c8ff62;
}

.gh-screen-bottom span:first-child::before {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 10px;
  content: "";
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 14px currentColor;
}

.gh-progress {
  position: absolute;
  right: 46px;
  bottom: 68px;
  left: 46px;
  height: 2px;
  background: rgba(255, 255, 255, 0.16);
}

.gh-progress i {
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf);
  transform-origin: left center;
}

.gh-screen-vignette {
  position: absolute;
  z-index: 45;
  inset: 0;
  box-shadow:
    inset 0 0 180px rgba(0, 0, 0, 0.54),
    inset 0 0 35px rgba(98, 231, 255, 0.05);
  pointer-events: none;
}

.gh-browser {
  position: absolute;
  z-index: 6;
  top: 110px;
  left: 105px;
  width: 1710px;
  height: 860px;
  overflow: hidden;
  border-radius: 44px;
  transform-origin: center;
}

.gh-browser-bar {
  display: grid;
  grid-template-columns: 1fr 1.5fr 1fr;
  align-items: center;
  height: 70px;
  padding: 0 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(5, 8, 22, 0.56);
  font-family: "DM Mono", monospace;
  font-size: 13px;
  letter-spacing: 0.06em;
}

.gh-browser-dots {
  display: flex;
  gap: 8px;
}

.gh-browser-dots i {
  width: 11px;
  height: 11px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.36);
}

.gh-browser-dots i:nth-child(1) {
  background: #ff7057;
}

.gh-browser-dots i:nth-child(2) {
  background: #c8ff62;
}

.gh-browser-url {
  padding: 12px 20px;
  color: rgba(247, 248, 255, 0.62);
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.055);
  text-align: center;
}

.gh-browser-actions {
  color: rgba(247, 248, 255, 0.55);
  text-align: right;
}

.gh-design-sidebar {
  position: absolute;
  top: 70px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 84px;
  padding: 22px 12px;
  border-right: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(5, 8, 22, 0.58);
}

.gh-design-sidebar button {
  display: grid;
  width: 48px;
  height: 48px;
  padding: 0;
  color: #f7f8ff;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 15px;
  background: rgba(255, 255, 255, 0.065);
  font-family: "DM Mono", monospace;
  font-size: 19px;
  place-items: center;
}

.gh-sidebar-label {
  margin: 5px 0 1px;
  color: rgba(247, 248, 255, 0.4);
  font-family: "DM Mono", monospace;
  font-size: 9px;
  letter-spacing: 0.12em;
}

.gh-design-sidebar > i {
  width: 34px;
  height: 34px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.22);
}

.gh-page-canvas {
  position: absolute;
  top: 94px;
  right: 195px;
  bottom: 28px;
  left: 110px;
  overflow: hidden;
  color: #101322;
  border-radius: 25px;
  background: #f6f5f1;
  box-shadow: 0 24px 65px rgba(0, 0, 0, 0.25);
}

.gh-page-nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  padding: 0 44px;
  font-family: "DM Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.1em;
  border-bottom: 1px solid rgba(16, 19, 34, 0.1);
}

.gh-page-grid {
  display: grid;
  grid-template-columns: 1fr 0.9fr;
  gap: 35px;
  padding: 38px 44px 24px;
}

.gh-page-copy {
  padding-top: 12px;
}

.gh-page-kicker {
  color: #5d6277;
  font-family: "DM Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.12em;
}

.gh-page-copy h2 {
  min-height: 128px;
  margin: 26px 0 14px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 60px;
  font-weight: 600;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.gh-page-copy h2 i {
  display: inline-block;
  width: 3px;
  height: 55px;
  margin-left: 5px;
  vertical-align: -8px;
  background: #5269ff;
}

.gh-page-copy p {
  max-width: 420px;
  margin: 0;
  color: #62677b;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 15px;
  line-height: 1.55;
}

.gh-page-button {
  display: inline-flex;
  align-items: center;
  gap: 24px;
  margin-top: 27px;
  padding: 14px 18px 14px 22px;
  color: #050816;
  border-radius: 16px;
  font-family: "DM Mono", monospace;
  font-size: 12px;
  font-weight: 600;
}

.gh-page-button svg {
  width: 24px;
}

.gh-page-image {
  position: relative;
  height: 390px;
  overflow: hidden;
  border-radius: 38px;
}

.gh-page-image > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gh-image-badge {
  position: absolute;
  right: 15px;
  bottom: 15px;
  padding: 11px 15px;
  color: #f7f8ff;
  border-radius: 13px;
  font-family: "DM Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.1em;
}

.gh-page-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  padding: 0 44px;
}

.gh-page-cards > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 76px;
  padding: 0 20px;
  border: 1px solid;
  border-radius: 20px;
  background: #fff;
}

.gh-page-cards span {
  color: #787d8e;
  font-family: "DM Mono", monospace;
  font-size: 10px;
}

.gh-page-cards strong {
  font-family: "Manrope", Arial, sans-serif;
  font-size: 16px;
}

.gh-properties {
  position: absolute;
  top: 94px;
  right: 20px;
  width: 155px;
  padding: 18px 15px;
  border-radius: 20px;
  font-family: "DM Mono", monospace;
  font-size: 9px;
}

.gh-properties > div {
  display: grid;
  grid-template-columns: 15px 1fr 15px 1fr;
  gap: 6px;
  margin-bottom: 12px;
}

.gh-properties span {
  color: rgba(247, 248, 255, 0.45);
}

.gh-properties strong {
  font-weight: 400;
}

.gh-property-color {
  grid-template-columns: 20px 1fr !important;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.gh-property-color i {
  grid-row: 1 / 3;
  width: 18px;
  height: 18px;
  border-radius: 6px;
  background: #62e7ff;
}

.gh-property-color strong {
  grid-column: 2;
  color: #62e7ff;
}

.gh-selection {
  position: absolute;
  z-index: 9;
  border: 2px solid;
  pointer-events: none;
}

.gh-selection > span {
  position: absolute;
  top: -24px;
  left: -2px;
  padding: 4px 7px;
  color: #050816;
  background: currentColor;
  font-family: "DM Mono", monospace;
  font-size: 8px;
  letter-spacing: 0.08em;
}

.gh-handle {
  position: absolute;
  width: 9px;
  height: 9px;
  border: 2px solid currentColor;
  background: #fff;
}

.gh-handle-tl {
  top: -6px;
  left: -6px;
}

.gh-handle-tr {
  top: -6px;
  right: -6px;
}

.gh-handle-bl {
  bottom: -6px;
  left: -6px;
}

.gh-handle-br {
  right: -6px;
  bottom: -6px;
}

.gh-design-cursor {
  position: absolute;
  z-index: 25;
  width: 48px;
  height: 56px;
  pointer-events: none;
  transform-origin: 8px 8px;
}

.gh-design-cursor svg {
  width: 42px;
  filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.35));
}

.gh-design-cursor span {
  position: absolute;
  top: 42px;
  left: 28px;
  padding: 5px 8px;
  color: #050816;
  border-radius: 6px;
  background: #c8ff62;
  font-family: "DM Mono", monospace;
  font-size: 8px;
  letter-spacing: 0.08em;
}

.gh-design-ripple {
  position: absolute;
  z-index: 24;
  width: 55px;
  height: 55px;
  border: 3px solid #c8ff62;
  border-radius: 50%;
  pointer-events: none;
}

/* GlassHudVertical */
.vh-glass {
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.17), rgba(255, 255, 255, 0.055));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.35),
    0 30px 80px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(28px) saturate(1.3);
}

.vh-photo-grade {
  background:
    radial-gradient(circle at 50% 38%, transparent, rgba(5, 8, 22, 0.25) 50%, rgba(5, 8, 22, 0.85)),
    linear-gradient(180deg, rgba(5, 8, 22, 0.08), rgba(5, 8, 22, 0.72));
}

.vh-hud {
  position: absolute;
  z-index: 90;
  inset: 0;
  padding: 34px 34px 38px;
  color: rgba(247, 248, 255, 0.72);
  font-family: "DM Mono", monospace;
  font-size: 13px;
  letter-spacing: 0.12em;
  pointer-events: none;
}

.vh-hud > div:first-child,
.vh-hud > div:nth-child(3) {
  display: flex;
  justify-content: space-between;
}

.vh-hud > div:nth-child(3) {
  position: absolute;
  right: 34px;
  bottom: 38px;
  left: 34px;
}

.vh-hud-progress {
  position: absolute;
  right: 34px;
  bottom: 74px;
  left: 34px;
  height: 2px;
  background: rgba(255, 255, 255, 0.15);
}

.vh-hud-progress i {
  display: block;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf, #c8ff62);
  transform-origin: left center;
}

.vh-live {
  color: #c8ff62;
}

.vh-live::before {
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 9px;
  content: "";
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 14px currentColor;
}

.vh-intro-ring {
  position: absolute;
  top: 520px;
  left: 50%;
  width: 620px;
  height: 620px;
  border-radius: 50%;
}

.vh-radar {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.vh-intro-ring::before,
.vh-intro-ring::after {
  position: absolute;
  content: "";
  border: 2px solid rgba(98, 231, 255, 0.5);
  border-radius: 50%;
}

.vh-intro-ring::before {
  inset: 65px;
  border-style: dashed;
}

.vh-intro-ring::after {
  inset: 130px;
  border-color: rgba(255, 101, 191, 0.55);
}

.vh-intro-ring i {
  position: absolute;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #62e7ff;
  box-shadow: 0 0 32px #62e7ff;
}

.vh-intro-ring i:nth-child(1) {
  top: 50%;
  left: -17px;
}

.vh-intro-ring i:nth-child(2) {
  top: -17px;
  left: 50%;
  background: #ff65bf;
  box-shadow: 0 0 32px #ff65bf;
}

.vh-intro-ring i:nth-child(3) {
  right: 30px;
  bottom: 70px;
  background: #c8ff62;
  box-shadow: 0 0 32px #c8ff62;
}

.vh-vertical-scan {
  position: absolute;
  z-index: 4;
  top: -300px;
  left: 380px;
  width: 190px;
  height: 1750px;
  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.26), rgba(255, 255, 255, 0.38), transparent);
  filter: blur(30px);
  mix-blend-mode: screen;
}

.vh-intro-copy {
  position: absolute;
  z-index: 6;
  top: 865px;
  left: 70px;
}

.vh-intro-copy > span,
.vh-wave-copy > span {
  font-family: "DM Mono", monospace;
  font-size: 15px;
  letter-spacing: 0.14em;
}

.vh-intro-copy h1,
.vh-cards-title,
.vh-wave-copy h2 {
  color: #f7f8ff;
  margin: 38px 0 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 108px;
  font-weight: 500;
  line-height: 0.94;
  letter-spacing: -0.065em;
}

.vh-intro-readouts {
  position: absolute;
  right: 65px;
  bottom: 230px;
  display: grid;
  gap: 8px;
  color: rgba(247, 248, 255, 0.54);
  font-family: "DM Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-align: right;
}

.vh-intro-copy h1 em,
.vh-cards-title em,
.vh-wave-copy h2 em {
  color: #62e7ff;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 1.15em;
  font-weight: 400;
}

.vh-data-pill {
  position: absolute;
  right: 64px;
  bottom: 130px;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 16px 40px;
  width: 340px;
  padding: 22px 26px;
  border-radius: 24px;
  font-family: "DM Mono", monospace;
  font-size: 13px;
}

.vh-data-pill strong {
  color: #c8ff62;
}

.vh-data-pill i {
  grid-column: 1 / -1;
  height: 4px;
  border-radius: 99px;
  background: linear-gradient(90deg, #5269ff, #62e7ff, #c8ff62);
}

.vh-scene-label {
  position: absolute;
  z-index: 10;
  top: 85px;
  left: 60px;
  color: rgba(247, 248, 255, 0.66);
  font-family: "DM Mono", monospace;
  font-size: 14px;
  letter-spacing: 0.14em;
}

.vh-cards-title {
  position: absolute;
  z-index: 5;
  top: 220px;
  left: 64px;
  margin: 0;
}

.vh-cards-title em {
  color: #ff65bf;
}

.vh-card-stack {
  position: absolute;
  z-index: 5;
  top: 670px;
  right: 55px;
  left: 55px;
  display: grid;
  gap: 24px;
}

.vh-vertical-dock {
  position: absolute;
  z-index: 8;
  right: 55px;
  bottom: 92px;
  left: 55px;
  display: flex;
  justify-content: center;
  gap: 13px;
  padding: 13px;
  border-radius: 30px;
}

.vh-vertical-dock span {
  display: grid;
  width: 58px;
  height: 58px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.07);
  font-family: "Manrope", Arial, sans-serif;
  font-size: 22px;
  place-items: center;
}

.vh-card {
  position: relative;
  height: 265px;
  padding: 28px;
  overflow: hidden;
  border-radius: 42px;
}

.vh-card > div {
  display: grid;
  width: 74px;
  height: 74px;
  border: 1px solid currentColor;
  border-radius: 25px;
  font-size: 30px;
  place-items: center;
}

.vh-card > span {
  position: absolute;
  bottom: 86px;
  color: rgba(247, 248, 255, 0.55);
  font-family: "DM Mono", monospace;
  font-size: 12px;
  letter-spacing: 0.12em;
}

.vh-card strong {
  position: absolute;
  bottom: 28px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 43px;
  font-weight: 500;
}

.vh-card > i {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 8px;
  height: 100%;
}

.vh-waves {
  position: absolute;
  z-index: 3;
  inset: 0;
}

.vh-wave-copy {
  position: absolute;
  z-index: 5;
  right: 55px;
  bottom: 280px;
  left: 55px;
  padding: 48px;
  border-radius: 48px;
}

.vh-wave-copy h2 {
  font-size: 104px;
}

.vh-wave-copy h2 em {
  color: #ff65bf;
}

.vh-wave-arrow {
  position: absolute;
  z-index: 8;
  top: 470px;
  left: 80px;
  display: grid;
  width: 100px;
  height: 100px;
  color: #050816;
  border-radius: 32px;
  background: #c8ff62;
  box-shadow: 0 0 48px rgba(200, 255, 98, 0.45);
  font-family: "Manrope", Arial, sans-serif;
  font-size: 50px;
  place-items: center;
}

.vh-wave-readout {
  position: absolute;
  z-index: 8;
  right: 60px;
  top: 210px;
  display: grid;
  grid-template-columns: auto auto;
  gap: 11px 25px;
  padding: 20px 22px;
  border-radius: 22px;
  font-family: "DM Mono", monospace;
  font-size: 11px;
}

.vh-wave-readout span {
  color: rgba(247, 248, 255, 0.5);
}

.vh-wave-readout strong {
  color: #62e7ff;
  font-weight: 400;
}

.vh-flow-heading {
  position: absolute;
  z-index: 7;
  top: 190px;
  left: 58px;
}

.vh-flow-heading > span {
  color: rgba(247, 248, 255, 0.58);
  font-family: "DM Mono", monospace;
  font-size: 12px;
  letter-spacing: 0.14em;
}

.vh-flow-heading h2 {
  margin: 28px 0 0;
  color: #f7f8ff;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 82px;
  font-weight: 500;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.vh-flow-heading h2 em {
  color: #62e7ff;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 1.12em;
  font-weight: 400;
}

.vh-flow-chamber {
  position: absolute;
  z-index: 6;
  top: 510px;
  right: 48px;
  left: 48px;
  height: 1040px;
  overflow: hidden;
  border-radius: 54px;
  transform-origin: center;
}

.vh-flow-top {
  position: absolute;
  z-index: 3;
  top: 28px;
  right: 30px;
  left: 30px;
  display: flex;
  justify-content: space-between;
  color: rgba(247, 248, 255, 0.62);
  font-family: "DM Mono", monospace;
  font-size: 11px;
  letter-spacing: 0.12em;
}

.vh-flow-top strong {
  color: #c8ff62;
  font-weight: 400;
}

.vh-flow-top i {
  display: inline-block;
  width: 7px;
  height: 7px;
  margin-left: 8px;
  border-radius: 50%;
  background: currentColor;
  box-shadow: 0 0 12px currentColor;
}

.vh-flow-mesh {
  position: absolute;
  top: 70px;
  left: 50%;
  width: 880px;
  height: 760px;
  transform: translateX(-50%);
}

.vh-flow-meters {
  position: absolute;
  right: 30px;
  bottom: 30px;
  left: 30px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}

.vh-flow-meters > div {
  padding: 17px;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 19px;
  background: rgba(5, 8, 22, 0.3);
}

.vh-flow-meters span,
.vh-flow-meters strong {
  display: block;
  font-family: "DM Mono", monospace;
}

.vh-flow-meters span {
  color: rgba(247, 248, 255, 0.42);
  font-size: 8px;
  letter-spacing: 0.1em;
}

.vh-flow-meters strong {
  margin: 9px 0 13px;
  color: #f7f8ff;
  font-size: 15px;
  font-weight: 400;
}

.vh-flow-meters i {
  display: block;
  height: 3px;
  overflow: hidden;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.12);
}

.vh-flow-meters b {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf);
  transform-origin: left center;
}

.vh-flow-sweep {
  position: absolute;
  z-index: 8;
  top: -240px;
  left: 350px;
  width: 170px;
  height: 1900px;
  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.2), rgba(255, 255, 255, 0.34), transparent);
  filter: blur(30px);
  mix-blend-mode: screen;
}

.vh-flow-tags {
  position: absolute;
  z-index: 9;
  right: 55px;
  bottom: 150px;
  left: 55px;
  display: flex;
  justify-content: center;
  gap: 12px;
}

.vh-flow-tags span {
  padding: 16px 20px;
  border-radius: 999px;
  font-family: "DM Mono", monospace;
  font-size: 9px;
  letter-spacing: 0.11em;
}

.vh-workspace {
  position: absolute;
  z-index: 6;
  top: 115px;
  left: 55px;
  width: 970px;
  height: 1660px;
  overflow: hidden;
  border-radius: 44px;
}

.vh-workspace-top {
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  align-items: center;
  height: 65px;
  padding: 0 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  background: rgba(5, 8, 22, 0.58);
  font-family: "DM Mono", monospace;
  font-size: 11px;
}

.vh-workspace-top > div {
  display: flex;
  gap: 7px;
}

.vh-workspace-top i {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.3);
}

.vh-workspace-top i:first-child {
  background: #ff7057;
}

.vh-workspace-top i:nth-child(2) {
  background: #c8ff62;
}

.vh-workspace-top > span {
  padding: 10px;
  color: rgba(247, 248, 255, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  text-align: center;
}

.vh-workspace-top strong {
  text-align: right;
}

.vh-toolbar {
  position: absolute;
  z-index: 5;
  top: 85px;
  left: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 58px;
  padding: 10px 7px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 20px;
  background: rgba(5, 8, 22, 0.78);
}

.vh-toolbar span {
  display: grid;
  width: 42px;
  height: 42px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 13px;
  font-family: "DM Mono", monospace;
  place-items: center;
}

.vh-toolbar > div {
  width: 35px;
  height: 1px;
  background: rgba(255, 255, 255, 0.15);
}

.vh-toolbar > i {
  width: 29px;
  height: 29px;
  border: 2px solid rgba(255, 255, 255, 0.22);
  border-radius: 50%;
}

.vh-mobile-frame {
  position: absolute;
  top: 85px;
  right: 56px;
  bottom: 30px;
  left: 94px;
  overflow: hidden;
  border-radius: 30px;
  background: #f6f5f1;
  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.32);
}

.vh-site-scroll {
  height: 2600px;
  color: #111322;
}

.vh-site-hero {
  height: 890px;
  padding: 35px;
}

.vh-site-hero nav {
  display: flex;
  justify-content: space-between;
  font-family: "DM Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.08em;
}

.vh-site-kicker {
  display: block;
  margin-top: 72px;
  color: #666b80;
  font-family: "DM Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.12em;
}

.vh-site-hero h2 {
  min-height: 145px;
  margin: 25px 0 12px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 61px;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.vh-site-hero h2 i {
  display: inline-block;
  width: 3px;
  height: 54px;
  margin-left: 5px;
  vertical-align: -8px;
  background: #5269ff;
}

.vh-site-hero p {
  margin: 0;
  color: #656a7c;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 14px;
  line-height: 1.55;
}

.vh-site-hero-image {
  position: relative;
  height: 390px;
  margin-top: 35px;
  overflow: hidden;
  border-radius: 32px;
}

.vh-site-hero-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.vh-site-hero-image span {
  position: absolute;
  right: 15px;
  bottom: 15px;
  padding: 10px 13px;
  color: #fff;
  border-radius: 11px;
  background: rgba(5, 8, 22, 0.65);
  font-family: "DM Mono", monospace;
  font-size: 9px;
}

.vh-site-services {
  min-height: 710px;
  padding: 50px 35px;
  color: #f7f8ff;
  background: #111322;
}

.vh-site-services > span,
.vh-site-testimonial > span,
.vh-site-footer > span {
  font-family: "DM Mono", monospace;
  font-size: 10px;
  letter-spacing: 0.12em;
}

.vh-site-services h3 {
  margin: 30px 0 35px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 51px;
  line-height: 0.98;
  letter-spacing: -0.055em;
}

.vh-site-services h3 em {
  color: #62e7ff;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 1.1em;
  font-weight: 400;
}

.vh-service-grid {
  display: grid;
  gap: 12px;
}

.vh-service-grid article {
  display: flex;
  align-items: center;
  height: 102px;
  padding: 0 20px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 22px;
  background: rgba(255, 255, 255, 0.06);
}

.vh-service-grid span {
  color: #62e7ff;
  font-family: "DM Mono", monospace;
  font-size: 10px;
}

.vh-service-grid strong {
  margin-left: 25px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 20px;
}

.vh-service-grid i {
  margin-left: auto;
  color: #c8ff62;
  font-size: 22px;
}

.vh-site-testimonial {
  min-height: 520px;
  padding: 55px 35px;
  background: #c8ff62;
}

.vh-site-testimonial blockquote {
  margin: 48px 0;
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 45px;
  line-height: 1.03;
}

.vh-site-testimonial > div {
  display: flex;
  align-items: center;
  gap: 15px;
  font-family: "DM Mono", monospace;
  font-size: 9px;
}

.vh-site-testimonial > div i {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #5269ff;
}

.vh-site-footer {
  min-height: 550px;
  padding: 55px 35px;
  color: #f7f8ff;
  background: linear-gradient(150deg, #5269ff, #9c6cff 55%, #ff65bf);
}

.vh-site-footer h3 {
  margin: 55px 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 70px;
  line-height: 0.9;
  letter-spacing: -0.06em;
}

.vh-site-footer button {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 22px;
  color: #111322;
  border: 0;
  border-radius: 18px;
  background: #c8ff62;
  font-family: "DM Mono", monospace;
  font-size: 12px;
}

.vh-scrollbar {
  position: absolute;
  z-index: 5;
  top: 100px;
  right: 25px;
  width: 4px;
  height: 1310px;
  overflow: hidden;
  border-radius: 99px;
  background: rgba(255, 255, 255, 0.1);
}

.vh-scrollbar i {
  display: block;
  width: 100%;
  height: 160px;
  border-radius: inherit;
  background: #62e7ff;
  box-shadow: 0 0 12px #62e7ff;
}

.vh-selection {
  position: absolute;
  z-index: 15;
  border: 2px solid;
  pointer-events: none;
}

.vh-selection > span {
  position: absolute;
  top: -23px;
  left: -2px;
  padding: 4px 7px;
  color: #050816;
  background: currentColor;
  font-family: "DM Mono", monospace;
  font-size: 8px;
}

.vh-selection i {
  position: absolute;
  width: 9px;
  height: 9px;
  border: 2px solid currentColor;
  background: #fff;
}

.vh-selection i:nth-of-type(1) {
  top: -6px;
  left: -6px;
}

.vh-selection i:nth-of-type(2) {
  top: -6px;
  right: -6px;
}

.vh-selection i:nth-of-type(3) {
  bottom: -6px;
  left: -6px;
}

.vh-selection i:nth-of-type(4) {
  right: -6px;
  bottom: -6px;
}

.vh-cursor {
  position: absolute;
  z-index: 30;
  width: 44px;
  transform-origin: 6px 6px;
}

.vh-cursor svg {
  width: 44px;
  filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.35));
}

.vh-cursor span {
  position: absolute;
  top: 39px;
  left: 24px;
  padding: 5px 7px;
  color: #050816;
  border-radius: 6px;
  background: #c8ff62;
  font-family: "DM Mono", monospace;
  font-size: 8px;
}

.vh-click {
  position: absolute;
  z-index: 29;
  width: 55px;
  height: 55px;
  border: 3px solid #c8ff62;
  border-radius: 50%;
}

.vh-dragged-service {
  position: absolute;
  z-index: 28;
  display: flex;
  align-items: center;
  width: 360px;
  height: 105px;
  padding: 0 22px;
  color: #f7f8ff;
  border: 1px solid #62e7ff;
  border-radius: 23px;
  background: rgba(17, 19, 34, 0.92);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.35);
}

.vh-dragged-service i {
  color: #62e7ff;
  font-family: "DM Mono", monospace;
  font-size: 11px;
}

.vh-dragged-service strong {
  margin-left: 24px;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 19px;
}

.vh-dragged-service span {
  margin-left: auto;
  color: #c8ff62;
}

.vh-vignette {
  position: absolute;
  z-index: 80;
  inset: 0;
  box-shadow: inset 0 0 150px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}

/* EditorialViralReel */
.ev-paper {
  color: #11110f;
  background:
    radial-gradient(circle at 50% 36%, rgba(255, 255, 255, 0.65), transparent 48%),
    #e7e4dd;
  overflow: hidden;
}

.ev-dark {
  color: #f4f1ea;
  background: #090909;
  overflow: hidden;
}

.ev-grain {
  position: absolute;
  z-index: 90;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  mix-blend-mode: multiply;
}

.ev-intro-object {
  position: absolute;
  top: 540px;
  left: 190px;
  width: 700px;
}

.ev-bloom {
  width: 100%;
  overflow: visible;
}

.ev-bloom-compact {
  width: 100%;
}

.ev-label {
  position: absolute;
  z-index: 5;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 49px;
  font-weight: 600;
  line-height: 0.98;
  letter-spacing: -0.045em;
}

.ev-label-top {
  top: 170px;
  right: 70px;
  text-align: right;
}

.ev-label-bottom {
  bottom: 175px;
  left: 64px;
}

.ev-label-bottom strong {
  font-size: 64px;
}

.ev-arrow-top,
.ev-arrow-bottom {
  position: absolute;
  color: #11110f;
}

.ev-arrow-top {
  top: 250px;
  left: 180px;
  width: 320px;
  transform: rotate(8deg);
}

.ev-arrow-bottom {
  right: 130px;
  bottom: 260px;
  width: 300px;
  transform: rotate(8deg);
}

.ev-curved-arrow {
  width: 100%;
}

.ev-index {
  position: absolute;
  top: 58px;
  left: 55px;
  font-family: "DM Mono", monospace;
  font-size: 13px;
  letter-spacing: 0.16em;
}

.ev-portal {
  position: absolute;
  z-index: 2;
  top: 49%;
  left: 50%;
  width: 680px;
  height: 860px;
  overflow: hidden;
  clip-path: polygon(12% 0, 88% 0, 100% 10%, 100% 90%, 88% 100%, 12% 100%, 0 90%, 0 10%);
  background: #181817;
  box-shadow: 24px 35px 42px rgba(0, 0, 0, 0.3);
}

.ev-figure {
  position: absolute;
  right: 0;
  bottom: -10px;
  left: 0;
  width: 100%;
}

.ev-panel {
  position: absolute;
  z-index: 4;
  top: 530px;
  width: 300px;
  height: 850px;
  overflow: hidden;
  background: #181817;
  box-shadow: 20px 25px 34px rgba(0, 0, 0, 0.26);
}

.ev-panel .ev-figure {
  width: 680px;
}

.ev-panel-left {
  left: 200px;
  clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 0 90%, 0 10%);
}

.ev-panel-left .ev-figure {
  left: 0;
}

.ev-panel-right {
  right: 200px;
  clip-path: polygon(0 0, 78% 0, 100% 10%, 100% 90%, 78% 100%, 0 100%);
}

.ev-panel-right .ev-figure {
  right: 0;
  left: auto;
}

.ev-panel-bloom {
  position: absolute;
  z-index: 6;
  top: 54%;
  left: 50%;
  width: 500px;
}

.ev-split-lines i {
  position: absolute;
  z-index: 7;
  top: 730px;
  width: 2px;
  height: 710px;
  background: rgba(17, 17, 15, 0.45);
}

.ev-split-lines i:first-child {
  left: 175px;
  transform: rotate(38deg);
}

.ev-split-lines i:last-child {
  right: 175px;
  transform: rotate(-38deg);
}

.ev-panel-copy {
  position: absolute;
  z-index: 8;
  top: 270px;
  left: 60px;
}

.ev-panel-copy span,
.ev-lens-copy span,
.ev-stage-copy span,
.ev-system-copy span {
  font-family: "DM Mono", monospace;
  font-size: 13px;
  letter-spacing: 0.13em;
}

.ev-panel-copy h2 {
  min-height: 110px;
  margin: 20px 0 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 78px;
  line-height: 0.95;
  letter-spacing: -0.06em;
}

.ev-panel-copy h2 i {
  display: inline-block;
  width: 4px;
  height: 72px;
  margin-left: 5px;
  vertical-align: -10px;
  background: #d64a3a;
}

.ev-lens-wrap {
  position: absolute;
  top: 51%;
  left: 50%;
  width: 680px;
}

.ev-lens-orb {
  width: 100%;
  overflow: visible;
}

.ev-analysis-lines {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.ev-lens-copy {
  position: absolute;
  top: 185px;
  left: 58px;
}

.ev-lens-copy h2 {
  margin: 25px 0 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 74px;
  line-height: 0.94;
  letter-spacing: -0.055em;
}

.ev-lens-copy h2 em {
  font-family: "Instrument Serif", Georgia, serif;
  font-size: 1.15em;
  font-weight: 400;
}

.ev-dark-camera {
  position: absolute;
  inset: 0;
  transform-origin: center 56%;
}

.ev-light-pool {
  position: absolute;
  z-index: 2;
  top: 48%;
  left: 50%;
  width: 620px;
  height: 620px;
  border-radius: 50%;
  background: #e7e4dd;
  transform: translate(-50%, -50%);
  box-shadow: 0 0 100px rgba(244, 241, 234, 0.2);
}

.ev-stage-bloom {
  position: absolute;
  z-index: 5;
  top: 48%;
  left: 50%;
  width: 430px;
}

.ev-spotlights {
  position: absolute;
  z-index: 4;
  top: 48%;
  left: 50%;
}

.ev-spotlight {
  position: absolute;
  bottom: -30px;
  left: 50%;
  clip-path: polygon(50% 100%, 0 0, 100% 0);
  background: linear-gradient(180deg, rgba(244, 241, 234, 0.04), rgba(244, 241, 234, 0.92));
  transform-origin: 50% 100%;
  mix-blend-mode: screen;
}

.ev-stage-copy {
  position: absolute;
  z-index: 10;
  top: 180px;
  left: 55px;
}

.ev-stage-copy h2,
.ev-system-copy h2 {
  margin: 22px 0 0;
  font-family: "Manrope", Arial, sans-serif;
  font-size: 70px;
  font-weight: 400;
  line-height: 0.92;
  letter-spacing: -0.055em;
}

.ev-stage-copy h2 strong,
.ev-system-copy h2 strong {
  font-size: 92px;
}

.ev-system-camera {
  position: absolute;
  top: 54%;
  left: -60px;
  width: 1700px;
  height: 960px;
  transform-origin: 540px 440px;
}

.ev-system-line {
  position: absolute;
  top: 440px;
  left: 0;
  width: 1680px;
  height: 4px;
  background: #e7e4dd;
  opacity: 0.7;
}

.ev-system-node {
  position: absolute;
  z-index: 4;
  top: 440px;
  width: 230px;
  height: 230px;
}

.ev-node-disc {
  position: absolute;
  z-index: 3;
  inset: 0;
  display: grid;
  border-radius: 50%;
  background: #e7e4dd;
  box-shadow: 0 0 55px rgba(244, 241, 234, 0.14);
  place-items: center;
}

.ev-node-disc .ev-bloom {
  width: 155px;
}

.ev-node-light {
  position: absolute;
  z-index: 2;
  bottom: 115px;
  left: 50%;
  width: 150px;
  height: 620px;
  clip-path: polygon(50% 100%, 0 0, 100% 0);
  background: linear-gradient(180deg, rgba(244, 241, 234, 0.92), rgba(244, 241, 234, 0.03));
  transform-origin: 50% 100%;
}

.ev-system-frames i {
  position: absolute;
  top: 655px;
  width: 190px;
  height: 260px;
  border: 3px solid rgba(231, 228, 221, 0.18);
  transform: translateX(-50%);
}

.ev-system-frames i::after {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 86px;
  height: 86px;
  content: "";
  border: 2px solid rgba(231, 228, 221, 0.2);
  transform: translate(-50%, -50%);
}

.ev-system-copy {
  position: absolute;
  z-index: 10;
  top: 145px;
  left: 55px;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ;;uEAEqE;EACrE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;EACrC,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,+CAA+C;EAC/C,gBAAgB;EAChB,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,4CAA4C;EAC5C,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb;;wEAEsE;EACtE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;+FAE6F;AAC/F;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,0FAA0F;EAC1F;;mCAEiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,aAAa;AACf;;AAEA;;;EAGE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;;EAIE,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gHAAgH;EAChH,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gHAAgH;EAChH,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,0EAA0E;EAC1E,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR;;2CAEyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,iDAAiD;EACjD,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,2CAA2C;EAC3C,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,2CAA2C;EAC3C,0FAA0F;EAC1F;;mCAEiC;EACjC,yCAAyC;AAC3C;;AAEA;EACE;;uEAEqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sEAAsE;EACtE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iHAAiH;EACjH,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,UAAU;EACV,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,aAAa;EACb,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,yCAAyC;EACzC,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,YAAY;EACZ,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;;EAEE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,6DAA6D;EAC7D,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gHAAgH;EAChH,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kDAAkD;EAClD,gCAAgC;EAChC,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;;;EAGE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,+CAA+C;EAC/C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,wBAAwB;EACxB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,8CAA8C;EAC9C,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd;;WAES;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,sFAAsF;EACtF,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,OAAO;EACP,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,oEAAoE;AACtE;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;;;;EAIE,iCAAiC;EACjC,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,yCAAyC;EACzC,yFAAyF;EACzF,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,yFAAyF;EACzF,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,UAAU;AACZ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Mono:wght@400;500&family=Instrument+Serif:ital@0;1&family=Manrope:wght@500;600&display=swap\");\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n}\n\n.corner-label {\n  position: absolute;\n  z-index: 20;\n  font-family: \"DM Mono\", monospace;\n  font-size: 17px;\n  letter-spacing: 0.16em;\n  line-height: 1;\n  text-transform: uppercase;\n}\n\n.top-left {\n  top: 50px;\n  left: 62px;\n}\n\n.top-right {\n  top: 50px;\n  right: 62px;\n}\n\n.bottom-left {\n  bottom: 50px;\n  left: 62px;\n}\n\n.bottom-right {\n  right: 62px;\n  bottom: 50px;\n}\n\n.orbit-dot {\n  position: absolute;\n  top: 50%;\n  left: -13px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  background: #ff5c35;\n  transform: translateY(-50%);\n}\n\n.orbit-dot.small {\n  left: auto;\n  right: -10px;\n  width: 20px;\n  height: 20px;\n  background: #4d64ff;\n}\n\n.intro-copy {\n  position: absolute;\n  top: 190px;\n  right: 100px;\n  width: 960px;\n}\n\n.eyebrow {\n  margin-bottom: 54px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 19px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.intro-copy h1,\n.final-copy h2 {\n  margin: 0 0 56px;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 150px;\n  font-weight: 400;\n  line-height: 0.84;\n  letter-spacing: -0.045em;\n}\n\n.intro-copy h1 em,\n.final-copy h2 em {\n  color: #4d64ff;\n  font-weight: 400;\n}\n\n.word-stack {\n  position: absolute;\n  inset: 130px 80px;\n  display: grid;\n  gap: 15px;\n}\n\n.word-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 255px;\n  padding: 10px 54px 25px;\n  overflow: hidden;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 210px;\n  line-height: 1;\n  letter-spacing: -0.045em;\n}\n\n.word-index {\n  align-self: flex-start;\n  margin-top: 28px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 19px;\n  letter-spacing: 0.1em;\n}\n\n.system-title {\n  position: absolute;\n  top: 140px;\n  left: 100px;\n}\n\n.system-title span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 18px;\n  letter-spacing: 0.14em;\n}\n\n.system-title h2 {\n  width: 1020px;\n  margin: 34px 0 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 112px;\n  font-weight: 400;\n  line-height: 0.92;\n  letter-spacing: -0.04em;\n}\n\n.metric-grid {\n  position: absolute;\n  right: 100px;\n  bottom: 125px;\n  left: 100px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n}\n\n.metric {\n  height: 335px;\n  padding: 34px;\n  color: #0a0a0a;\n}\n\n.metric-label {\n  font-family: \"DM Mono\", monospace;\n  font-size: 17px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.metric-value {\n  margin-top: 118px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 48px;\n  font-weight: 600;\n  letter-spacing: -0.045em;\n}\n\n.metric-line {\n  height: 3px;\n  margin-top: 28px;\n  background: rgba(10, 10, 10, 0.2);\n}\n\n.metric-line > div {\n  width: 100%;\n  height: 100%;\n  background: #0a0a0a;\n  transform-origin: left center;\n}\n\n.final-accent {\n  position: absolute;\n  top: -260px;\n  right: -220px;\n  width: 850px;\n  height: 1500px;\n  background: #d9ff43;\n}\n\n.final-copy {\n  position: absolute;\n  top: 205px;\n  left: 105px;\n  width: 1250px;\n}\n\n.eyebrow.light {\n  color: #a8a8a0;\n}\n\n.final-copy h2 {\n  color: #f0eee7;\n  font-size: 160px;\n}\n\n.final-copy h2 em {\n  color: #d9ff43;\n}\n\n.final-rule {\n  width: 780px;\n  height: 3px;\n  background: #f0eee7;\n  transform-origin: left center;\n}\n\n/* PremiumMotion */\n.pm-camera {\n  position: absolute;\n  inset: 0;\n  transform-origin: center;\n}\n\n.pm-tech {\n  position: absolute;\n  z-index: 40;\n  inset: 0;\n  font-family: \"DM Mono\", monospace;\n  font-size: 16px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  pointer-events: none;\n}\n\n.pm-tech span {\n  position: absolute;\n}\n\n.pm-tech-tl {\n  top: 46px;\n  left: 58px;\n}\n\n.pm-tech-tr {\n  top: 46px;\n  right: 58px;\n}\n\n.pm-tech-bl {\n  bottom: 46px;\n  left: 58px;\n}\n\n.pm-tech-br {\n  right: 58px;\n  bottom: 46px;\n}\n\n.pm-precision-camera {\n  top: 155px;\n  right: 110px;\n  bottom: auto;\n  left: 110px;\n}\n\n.pm-precision-kicker,\n.pm-focus-copy > span,\n.pm-final-copy > span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 18px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.pm-precision-title {\n  position: relative;\n  z-index: 2;\n  margin: 72px 0 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 205px;\n  font-weight: 400;\n  line-height: 0.78;\n  letter-spacing: -0.055em;\n}\n\n.pm-chromatic {\n  position: relative;\n  display: block;\n  isolation: isolate;\n}\n\n.pm-chromatic-base,\n.pm-chromatic-color {\n  display: block;\n}\n\n.pm-chromatic-base {\n  position: relative;\n  z-index: 3;\n}\n\n.pm-chromatic-color {\n  position: absolute;\n  inset: 0;\n  opacity: 0.78;\n  mix-blend-mode: screen;\n}\n\n.pm-chromatic-blue {\n  z-index: 1;\n  color: #3155ff;\n}\n\n.pm-chromatic-red {\n  z-index: 2;\n  color: #ff4f38;\n}\n\n.pm-precision-italic {\n  display: block;\n  padding-left: 390px;\n  color: #d8ff3e;\n  font-style: italic;\n}\n\n.pm-rule {\n  width: 1170px;\n  height: 3px;\n  margin-top: 90px;\n  background: rgba(243, 240, 232, 0.18);\n}\n\n.pm-rule > div {\n  width: 100%;\n  height: 100%;\n  background: #f3f0e8;\n  transform-origin: left center;\n}\n\n.pm-color-orb {\n  position: absolute;\n  width: 620px;\n  height: 620px;\n  border-radius: 50%;\n  filter: blur(110px);\n  mix-blend-mode: screen;\n}\n\n.pm-orb-blue {\n  right: -130px;\n  bottom: -220px;\n  background: #3155ff;\n}\n\n.pm-orb-red {\n  top: -280px;\n  right: 360px;\n  background: #ff4f38;\n}\n\n.pm-aperture-camera {\n  display: grid;\n  place-items: center;\n  transform-origin: 47% 50%;\n}\n\n.pm-aperture {\n  width: 780px;\n  height: 780px;\n}\n\n.pm-focus-copy {\n  position: absolute;\n  z-index: 5;\n  top: 250px;\n  right: 120px;\n  width: 760px;\n}\n\n.pm-focus-copy h2,\n.pm-final-copy h2 {\n  margin: 50px 0 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 118px;\n  font-weight: 400;\n  line-height: 0.9;\n  letter-spacing: -0.045em;\n}\n\n.pm-focus-copy h2 em {\n  color: #3155ff;\n  font-weight: 400;\n}\n\n.pm-ribbon {\n  position: absolute;\n  left: -300px;\n  display: flex;\n  align-items: center;\n  gap: 90px;\n  width: 2550px;\n  height: 215px;\n  padding: 0 36px 18px;\n  overflow: hidden;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 155px;\n  line-height: 1;\n  letter-spacing: -0.045em;\n  white-space: nowrap;\n  transform-origin: center;\n}\n\n.pm-flow-caption {\n  position: absolute;\n  z-index: 20;\n  right: 76px;\n  bottom: 72px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 18px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.pm-final-camera {\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: 100px;\n  align-items: center;\n  padding: 120px 105px;\n}\n\n.pm-final-copy {\n  position: relative;\n  z-index: 3;\n}\n\n.pm-final-copy h2 {\n  font-size: 135px;\n}\n\n.pm-final-copy h2 em {\n  color: #d8ff3e;\n  font-weight: 400;\n}\n\n.pm-bezier-wrap {\n  position: relative;\n  z-index: 3;\n}\n\n.pm-bezier {\n  width: 720px;\n}\n\n.pm-curve-label {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 20px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 16px;\n  letter-spacing: 0.12em;\n}\n\n.pm-curve-label span {\n  color: #9f9d97;\n}\n\n.pm-final-flood {\n  position: absolute;\n  z-index: 2;\n  inset: 0;\n  background: #d8ff3e;\n  transform-origin: left center;\n}\n\n/* TableJourney */\n.tj-world {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 5200px;\n  height: 3400px;\n  color: #11100e;\n  background: #eae6dd;\n  transform-origin: 960px 540px;\n}\n\n.tj-grid {\n  position: absolute;\n  inset: 0;\n  opacity: 0.3;\n  background-image:\n    linear-gradient(rgba(17, 16, 14, 0.12) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(17, 16, 14, 0.12) 1px, transparent 1px);\n  background-size: 80px 80px;\n}\n\n.tj-world-label {\n  position: absolute;\n  top: 70px;\n  left: 70px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 15px;\n  letter-spacing: 0.14em;\n}\n\n.tj-group {\n  position: absolute;\n  width: 1920px;\n  height: 1080px;\n  overflow: hidden;\n}\n\n.tj-type-group {\n  top: 0;\n  left: 0;\n}\n\n.tj-material-group {\n  top: -100px;\n  left: 2200px;\n}\n\n.tj-icon-group {\n  top: 1350px;\n  left: 2200px;\n}\n\n.tj-finale-group {\n  top: 1450px;\n  left: 0;\n  color: #f8f5ed;\n  background: #11100e;\n}\n\n.tj-group-index {\n  position: absolute;\n  top: 86px;\n  left: 100px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 17px;\n  letter-spacing: 0.14em;\n}\n\n.tj-type-stage {\n  position: absolute;\n  top: 260px;\n  left: 105px;\n}\n\n.tj-type-line {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 172px;\n  line-height: 0.86;\n  letter-spacing: -0.055em;\n  white-space: nowrap;\n}\n\n.tj-type-line-two {\n  margin-left: 305px;\n  color: #4f63ff;\n  font-style: italic;\n}\n\n.tj-type-mask {\n  width: 1220px;\n  height: 24px;\n  margin-top: 82px;\n  background: #11100e;\n  transform-origin: left center;\n}\n\n.tj-note {\n  position: absolute;\n  display: grid;\n  grid-template-columns: 50px 1fr;\n  gap: 18px;\n  align-items: center;\n  font-family: \"DM Mono\", monospace;\n  font-size: 17px;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.tj-note span {\n  display: grid;\n  width: 50px;\n  height: 50px;\n  color: #11100e;\n  border: 1px solid #11100e;\n  border-radius: 50%;\n  place-items: center;\n}\n\n.tj-note-a {\n  right: 130px;\n  bottom: 130px;\n}\n\n.tj-orbit {\n  position: absolute;\n  top: 170px;\n  right: 180px;\n  width: 240px;\n  height: 240px;\n  border: 2px solid #11100e;\n  border-radius: 50%;\n}\n\n.tj-orbit div {\n  position: absolute;\n  top: 50%;\n  left: -15px;\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  background: #cfff38;\n  transform: translateY(-50%);\n}\n\n.tj-material-title,\n.tj-icon-title {\n  position: absolute;\n  top: 145px;\n  left: 100px;\n  margin: 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 112px;\n  font-weight: 400;\n  line-height: 0.9;\n  letter-spacing: -0.045em;\n}\n\n.tj-material-title em,\n.tj-icon-title em {\n  color: #4f63ff;\n  font-weight: 400;\n}\n\n.tj-material-cards {\n  position: absolute;\n  right: 110px;\n  bottom: 115px;\n  left: 110px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 24px;\n}\n\n.tj-material-card {\n  position: relative;\n  height: 400px;\n  padding: 34px;\n  box-shadow: 0 26px 55px rgba(17, 16, 14, 0.13);\n}\n\n.tj-material-card span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 16px;\n}\n\n.tj-material-card strong {\n  position: absolute;\n  bottom: 55px;\n  left: 34px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 49px;\n  letter-spacing: -0.04em;\n}\n\n.tj-card-rule {\n  position: absolute;\n  right: 34px;\n  bottom: 35px;\n  left: 34px;\n  height: 3px;\n  background: #11100e;\n}\n\n.tj-lens {\n  position: absolute;\n  z-index: 5;\n  top: 130px;\n  right: 310px;\n  width: 330px;\n  height: 330px;\n  border: 3px solid #11100e;\n  border-radius: 50%;\n  background: rgba(255, 104, 181, 0.42);\n  backdrop-filter: blur(7px);\n  mix-blend-mode: multiply;\n}\n\n.tj-icon-title {\n  top: 155px;\n}\n\n.tj-icon-title em {\n  color: #ff6846;\n}\n\n.tj-icon-row {\n  position: absolute;\n  right: 110px;\n  bottom: 150px;\n  left: 110px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n}\n\n.tj-icon-tile {\n  display: grid;\n  height: 390px;\n  padding: 30px;\n  border: 2px solid #11100e;\n  place-items: center;\n}\n\n.tj-icon-tile svg {\n  width: 260px;\n  height: 260px;\n}\n\n.tj-icon-tile span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 16px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.tj-connection-line {\n  position: absolute;\n  right: 110px;\n  bottom: 105px;\n  left: 110px;\n  height: 3px;\n  background: rgba(17, 16, 14, 0.2);\n}\n\n.tj-connection-line div {\n  width: 100%;\n  height: 100%;\n  background: #11100e;\n  transform-origin: left center;\n}\n\n.tj-final-words {\n  position: absolute;\n  top: 300px;\n  left: 100px;\n  display: flex;\n  overflow: hidden;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 230px;\n  line-height: 1;\n  letter-spacing: -0.065em;\n}\n\n.tj-final-words span {\n  display: inline-block;\n}\n\n.tj-final-copy {\n  position: absolute;\n  bottom: 150px;\n  left: 110px;\n  margin: 0;\n  font-family: \"DM Mono\", monospace;\n  font-size: 19px;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.tj-final-circle {\n  position: absolute;\n  top: 50%;\n  right: 75px;\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  background: #4f63ff;\n  mix-blend-mode: screen;\n}\n\n.tj-corner-data {\n  position: absolute;\n  z-index: 50;\n  inset: 0;\n  color: #f8f5ed;\n  font-family: \"DM Mono\", monospace;\n  font-size: 15px;\n  letter-spacing: 0.12em;\n  pointer-events: none;\n  mix-blend-mode: difference;\n}\n\n.tj-corner-data span {\n  position: absolute;\n}\n\n.tj-corner-data span:nth-child(1) {\n  top: 44px;\n  left: 54px;\n}\n\n.tj-corner-data span:nth-child(2) {\n  top: 44px;\n  right: 54px;\n}\n\n.tj-corner-data span:nth-child(3) {\n  bottom: 44px;\n  left: 54px;\n}\n\n.tj-morph-cursor {\n  position: absolute;\n  z-index: 45;\n  top: 50%;\n  left: 50%;\n  box-shadow: 0 8px 28px rgba(17, 16, 14, 0.2);\n  pointer-events: none;\n  mix-blend-mode: difference;\n}\n\n.tj-parallax {\n  position: absolute;\n  z-index: 30;\n  inset: -15%;\n  pointer-events: none;\n}\n\n.tj-parallax i {\n  position: absolute;\n  display: block;\n  border-radius: 50%;\n  opacity: 0.5;\n  mix-blend-mode: difference;\n}\n\n.tj-vignette {\n  position: absolute;\n  z-index: 44;\n  inset: 0;\n  box-shadow: inset 0 0 180px rgba(0, 0, 0, 0.3);\n  pointer-events: none;\n}\n\n/* GlassHudJourney */\n.gh-world {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 4140px;\n  height: 3600px;\n  color: #f7f8ff;\n  background: #050816;\n  transform-origin: 960px 540px;\n}\n\n.gh-world-grid {\n  position: absolute;\n  inset: 0;\n  opacity: 0.16;\n  background-image:\n    linear-gradient(rgba(98, 231, 255, 0.2) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(98, 231, 255, 0.2) 1px, transparent 1px);\n  background-size: 72px 72px;\n}\n\n.gh-aurora {\n  position: absolute;\n  width: 1200px;\n  height: 1200px;\n  border-radius: 50%;\n  filter: blur(210px);\n  opacity: 0.34;\n}\n\n.gh-aurora-a {\n  top: -430px;\n  left: 530px;\n  background: #5269ff;\n}\n\n.gh-aurora-b {\n  right: 150px;\n  bottom: -380px;\n  background: #ff65bf;\n}\n\n.gh-station {\n  position: absolute;\n  width: 1920px;\n  height: 1080px;\n  overflow: hidden;\n}\n\n.gh-photo-plate {\n  position: absolute;\n  z-index: 0;\n  inset: 0;\n  overflow: hidden;\n}\n\n.gh-photo-grade {\n  position: absolute;\n  inset: 0;\n  background:\n    radial-gradient(circle at 68% 42%, transparent 0%, rgba(5, 8, 22, 0.18) 42%, rgba(5, 8, 22, 0.76) 100%),\n    linear-gradient(90deg, rgba(5, 8, 22, 0.7), rgba(5, 8, 22, 0.08) 55%, rgba(5, 8, 22, 0.48));\n}\n\n.gh-intro {\n  top: 0;\n  left: 0;\n}\n\n.gh-system {\n  top: 0;\n  left: 2120px;\n}\n\n.gh-waves {\n  top: 1260px;\n  left: 2120px;\n}\n\n.gh-finale {\n  top: 1260px;\n  left: 0;\n}\n\n.gh-design-lab {\n  top: 2520px;\n  left: 0;\n}\n\n.gh-station-label {\n  position: absolute;\n  z-index: 8;\n  top: 76px;\n  left: 86px;\n  color: rgba(247, 248, 255, 0.64);\n  font-family: \"DM Mono\", monospace;\n  font-size: 16px;\n  letter-spacing: 0.16em;\n}\n\n.gh-glass {\n  border: 1px solid rgba(255, 255, 255, 0.26);\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0.055));\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.34),\n    0 30px 80px rgba(0, 0, 0, 0.26);\n  backdrop-filter: blur(28px) saturate(1.3);\n}\n\n.gh-intro-copy {\n  position: absolute;\n  z-index: 5;\n  top: 230px;\n  left: 92px;\n  width: 1040px;\n}\n\n.gh-intro-copy > span,\n.gh-wave-copy > span,\n.gh-final-copy > span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 17px;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.gh-intro-copy h1,\n.gh-system-title,\n.gh-wave-copy h2,\n.gh-final-copy h2 {\n  margin: 44px 0 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 112px;\n  font-weight: 500;\n  line-height: 0.94;\n  letter-spacing: -0.06em;\n}\n\n.gh-intro-copy h1 em,\n.gh-system-title em,\n.gh-wave-copy h2 em,\n.gh-final-copy h2 em {\n  color: #62e7ff;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 1.18em;\n  font-weight: 400;\n}\n\n.gh-radar-card {\n  position: absolute;\n  z-index: 6;\n  top: 168px;\n  right: 100px;\n  width: 520px;\n  height: 690px;\n  padding: 32px;\n  overflow: hidden;\n  border-radius: 54px;\n}\n\n.gh-card-head,\n.gh-card-foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  color: rgba(247, 248, 255, 0.72);\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.12em;\n}\n\n.gh-card-head i {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #c8ff62;\n  box-shadow: 0 0 18px #c8ff62;\n}\n\n.gh-radar {\n  width: 100%;\n  margin-top: 55px;\n  color: #62e7ff;\n}\n\n.gh-card-foot {\n  margin-top: 55px;\n}\n\n.gh-mini-hud {\n  position: absolute;\n  z-index: 6;\n  right: 150px;\n  bottom: 86px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px 40px;\n  width: 420px;\n  padding: 22px 26px;\n  border-radius: 24px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n}\n\n.gh-mini-hud strong {\n  color: #c8ff62;\n  font-size: 20px;\n}\n\n.gh-mini-hud > div {\n  grid-column: 1 / -1;\n  height: 5px;\n  overflow: hidden;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.gh-mini-hud i {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #5269ff, #62e7ff, #c8ff62);\n  transform-origin: left center;\n}\n\n.gh-scan-light {\n  position: absolute;\n  z-index: 4;\n  top: -250px;\n  left: 610px;\n  width: 240px;\n  height: 1550px;\n  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.3), rgba(255, 255, 255, 0.42), transparent);\n  filter: blur(28px);\n  mix-blend-mode: screen;\n}\n\n.gh-system-title {\n  position: absolute;\n  top: 150px;\n  left: 92px;\n  margin: 0;\n}\n\n.gh-system-title em {\n  color: #ff65bf;\n}\n\n.gh-module-grid {\n  position: absolute;\n  right: 90px;\n  bottom: 150px;\n  left: 90px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 26px;\n  perspective: 1200px;\n}\n\n.gh-module {\n  position: relative;\n  height: 425px;\n  padding: 34px;\n  overflow: hidden;\n  border-radius: 46px;\n}\n\n.gh-module-icon {\n  display: grid;\n  width: 82px;\n  height: 82px;\n  border: 1px solid currentColor;\n  border-radius: 26px;\n  place-items: center;\n}\n\n.gh-module-icon svg,\n.gh-module-arrow svg {\n  width: 42px;\n  height: 42px;\n}\n\n.gh-module > span {\n  position: absolute;\n  bottom: 125px;\n  color: rgba(247, 248, 255, 0.56);\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.12em;\n}\n\n.gh-module h3 {\n  position: absolute;\n  bottom: 50px;\n  margin: 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 48px;\n  font-weight: 500;\n  letter-spacing: -0.045em;\n}\n\n.gh-module-arrow {\n  position: absolute;\n  right: 34px;\n  bottom: 34px;\n  color: rgba(247, 248, 255, 0.65);\n}\n\n.gh-glass-shine {\n  position: absolute;\n  top: -150px;\n  left: -240px;\n  width: 160px;\n  height: 750px;\n  background: rgba(255, 255, 255, 0.35);\n  filter: blur(24px);\n}\n\n.gh-dock {\n  position: absolute;\n  z-index: 8;\n  bottom: 60px;\n  left: 50%;\n  display: flex;\n  gap: 12px;\n  padding: 12px;\n  border-radius: 28px;\n  transform: translateX(-50%);\n}\n\n.gh-dock span {\n  display: grid;\n  width: 58px;\n  height: 58px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 19px;\n  background: rgba(255, 255, 255, 0.08);\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 23px;\n  place-items: center;\n}\n\n.gh-wave-field {\n  position: absolute;\n  top: 210px;\n  left: 230px;\n  width: 1500px;\n  height: 620px;\n}\n\n.gh-wave-copy {\n  position: absolute;\n  z-index: 6;\n  top: 280px;\n  left: 135px;\n  width: 710px;\n  padding: 48px;\n  border-radius: 48px;\n}\n\n.gh-wave-copy h2 {\n  font-size: 94px;\n}\n\n.gh-wave-copy h2 em {\n  color: #ff65bf;\n}\n\n.gh-flight-arrow {\n  position: absolute;\n  z-index: 8;\n  top: 260px;\n  left: 950px;\n  display: grid;\n  width: 110px;\n  height: 110px;\n  color: #050816;\n  border-radius: 35px;\n  background: #c8ff62;\n  box-shadow: 0 0 50px rgba(200, 255, 98, 0.45);\n  place-items: center;\n}\n\n.gh-flight-arrow svg {\n  width: 62px;\n}\n\n.gh-wave-data {\n  position: absolute;\n  right: 100px;\n  bottom: 90px;\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 14px 34px;\n  padding: 25px 30px;\n  color: rgba(247, 248, 255, 0.68);\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  border-left: 2px solid #62e7ff;\n}\n\n.gh-wave-data strong {\n  color: #f7f8ff;\n  font-weight: 400;\n}\n\n.gh-final-copy {\n  position: absolute;\n  z-index: 6;\n  top: 230px;\n  left: 110px;\n}\n\n.gh-final-copy h2 {\n  font-size: 136px;\n}\n\n.gh-final-copy h2 em {\n  color: #c8ff62;\n}\n\n.gh-final-light {\n  position: absolute;\n  top: -580px;\n  left: 600px;\n  width: 480px;\n  height: 2200px;\n  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.18), rgba(255, 255, 255, 0.4), transparent);\n  filter: blur(45px);\n  mix-blend-mode: screen;\n}\n\n.gh-final-pills {\n  position: absolute;\n  z-index: 7;\n  right: 100px;\n  bottom: 100px;\n  display: flex;\n  gap: 14px;\n}\n\n.gh-final-pills span {\n  min-width: 160px;\n  padding: 20px 26px;\n  border-radius: 999px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.14em;\n  text-align: center;\n}\n\n.gh-swipe {\n  position: absolute;\n  z-index: 5;\n  inset: 0;\n  background: linear-gradient(100deg, #5269ff 0%, #9c6cff 45%, #ff65bf 100%);\n  transform-origin: left center;\n  mix-blend-mode: screen;\n}\n\n.gh-screen-hud {\n  position: absolute;\n  z-index: 50;\n  inset: 0;\n  color: rgba(247, 248, 255, 0.72);\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.14em;\n  pointer-events: none;\n}\n\n.gh-screen-top,\n.gh-screen-bottom {\n  position: absolute;\n  right: 46px;\n  left: 46px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.gh-screen-top {\n  top: 34px;\n}\n\n.gh-screen-bottom {\n  bottom: 34px;\n}\n\n.gh-screen-bottom span:first-child {\n  color: #c8ff62;\n}\n\n.gh-screen-bottom span:first-child::before {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin-right: 10px;\n  content: \"\";\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 14px currentColor;\n}\n\n.gh-progress {\n  position: absolute;\n  right: 46px;\n  bottom: 68px;\n  left: 46px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.16);\n}\n\n.gh-progress i {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf);\n  transform-origin: left center;\n}\n\n.gh-screen-vignette {\n  position: absolute;\n  z-index: 45;\n  inset: 0;\n  box-shadow:\n    inset 0 0 180px rgba(0, 0, 0, 0.54),\n    inset 0 0 35px rgba(98, 231, 255, 0.05);\n  pointer-events: none;\n}\n\n.gh-browser {\n  position: absolute;\n  z-index: 6;\n  top: 110px;\n  left: 105px;\n  width: 1710px;\n  height: 860px;\n  overflow: hidden;\n  border-radius: 44px;\n  transform-origin: center;\n}\n\n.gh-browser-bar {\n  display: grid;\n  grid-template-columns: 1fr 1.5fr 1fr;\n  align-items: center;\n  height: 70px;\n  padding: 0 24px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(5, 8, 22, 0.56);\n  font-family: \"DM Mono\", monospace;\n  font-size: 13px;\n  letter-spacing: 0.06em;\n}\n\n.gh-browser-dots {\n  display: flex;\n  gap: 8px;\n}\n\n.gh-browser-dots i {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.36);\n}\n\n.gh-browser-dots i:nth-child(1) {\n  background: #ff7057;\n}\n\n.gh-browser-dots i:nth-child(2) {\n  background: #c8ff62;\n}\n\n.gh-browser-url {\n  padding: 12px 20px;\n  color: rgba(247, 248, 255, 0.62);\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.055);\n  text-align: center;\n}\n\n.gh-browser-actions {\n  color: rgba(247, 248, 255, 0.55);\n  text-align: right;\n}\n\n.gh-design-sidebar {\n  position: absolute;\n  top: 70px;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  width: 84px;\n  padding: 22px 12px;\n  border-right: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(5, 8, 22, 0.58);\n}\n\n.gh-design-sidebar button {\n  display: grid;\n  width: 48px;\n  height: 48px;\n  padding: 0;\n  color: #f7f8ff;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 15px;\n  background: rgba(255, 255, 255, 0.065);\n  font-family: \"DM Mono\", monospace;\n  font-size: 19px;\n  place-items: center;\n}\n\n.gh-sidebar-label {\n  margin: 5px 0 1px;\n  color: rgba(247, 248, 255, 0.4);\n  font-family: \"DM Mono\", monospace;\n  font-size: 9px;\n  letter-spacing: 0.12em;\n}\n\n.gh-design-sidebar > i {\n  width: 34px;\n  height: 34px;\n  border: 3px solid rgba(255, 255, 255, 0.25);\n  border-radius: 50%;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.22);\n}\n\n.gh-page-canvas {\n  position: absolute;\n  top: 94px;\n  right: 195px;\n  bottom: 28px;\n  left: 110px;\n  overflow: hidden;\n  color: #101322;\n  border-radius: 25px;\n  background: #f6f5f1;\n  box-shadow: 0 24px 65px rgba(0, 0, 0, 0.25);\n}\n\n.gh-page-nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 66px;\n  padding: 0 44px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n  letter-spacing: 0.1em;\n  border-bottom: 1px solid rgba(16, 19, 34, 0.1);\n}\n\n.gh-page-grid {\n  display: grid;\n  grid-template-columns: 1fr 0.9fr;\n  gap: 35px;\n  padding: 38px 44px 24px;\n}\n\n.gh-page-copy {\n  padding-top: 12px;\n}\n\n.gh-page-kicker {\n  color: #5d6277;\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n  letter-spacing: 0.12em;\n}\n\n.gh-page-copy h2 {\n  min-height: 128px;\n  margin: 26px 0 14px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 60px;\n  font-weight: 600;\n  line-height: 0.95;\n  letter-spacing: -0.06em;\n}\n\n.gh-page-copy h2 i {\n  display: inline-block;\n  width: 3px;\n  height: 55px;\n  margin-left: 5px;\n  vertical-align: -8px;\n  background: #5269ff;\n}\n\n.gh-page-copy p {\n  max-width: 420px;\n  margin: 0;\n  color: #62677b;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 15px;\n  line-height: 1.55;\n}\n\n.gh-page-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 24px;\n  margin-top: 27px;\n  padding: 14px 18px 14px 22px;\n  color: #050816;\n  border-radius: 16px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.gh-page-button svg {\n  width: 24px;\n}\n\n.gh-page-image {\n  position: relative;\n  height: 390px;\n  overflow: hidden;\n  border-radius: 38px;\n}\n\n.gh-page-image > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.gh-image-badge {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n  padding: 11px 15px;\n  color: #f7f8ff;\n  border-radius: 13px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n  letter-spacing: 0.1em;\n}\n\n.gh-page-cards {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n  padding: 0 44px;\n}\n\n.gh-page-cards > div {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 76px;\n  padding: 0 20px;\n  border: 1px solid;\n  border-radius: 20px;\n  background: #fff;\n}\n\n.gh-page-cards span {\n  color: #787d8e;\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n}\n\n.gh-page-cards strong {\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 16px;\n}\n\n.gh-properties {\n  position: absolute;\n  top: 94px;\n  right: 20px;\n  width: 155px;\n  padding: 18px 15px;\n  border-radius: 20px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 9px;\n}\n\n.gh-properties > div {\n  display: grid;\n  grid-template-columns: 15px 1fr 15px 1fr;\n  gap: 6px;\n  margin-bottom: 12px;\n}\n\n.gh-properties span {\n  color: rgba(247, 248, 255, 0.45);\n}\n\n.gh-properties strong {\n  font-weight: 400;\n}\n\n.gh-property-color {\n  grid-template-columns: 20px 1fr !important;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.gh-property-color i {\n  grid-row: 1 / 3;\n  width: 18px;\n  height: 18px;\n  border-radius: 6px;\n  background: #62e7ff;\n}\n\n.gh-property-color strong {\n  grid-column: 2;\n  color: #62e7ff;\n}\n\n.gh-selection {\n  position: absolute;\n  z-index: 9;\n  border: 2px solid;\n  pointer-events: none;\n}\n\n.gh-selection > span {\n  position: absolute;\n  top: -24px;\n  left: -2px;\n  padding: 4px 7px;\n  color: #050816;\n  background: currentColor;\n  font-family: \"DM Mono\", monospace;\n  font-size: 8px;\n  letter-spacing: 0.08em;\n}\n\n.gh-handle {\n  position: absolute;\n  width: 9px;\n  height: 9px;\n  border: 2px solid currentColor;\n  background: #fff;\n}\n\n.gh-handle-tl {\n  top: -6px;\n  left: -6px;\n}\n\n.gh-handle-tr {\n  top: -6px;\n  right: -6px;\n}\n\n.gh-handle-bl {\n  bottom: -6px;\n  left: -6px;\n}\n\n.gh-handle-br {\n  right: -6px;\n  bottom: -6px;\n}\n\n.gh-design-cursor {\n  position: absolute;\n  z-index: 25;\n  width: 48px;\n  height: 56px;\n  pointer-events: none;\n  transform-origin: 8px 8px;\n}\n\n.gh-design-cursor svg {\n  width: 42px;\n  filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.35));\n}\n\n.gh-design-cursor span {\n  position: absolute;\n  top: 42px;\n  left: 28px;\n  padding: 5px 8px;\n  color: #050816;\n  border-radius: 6px;\n  background: #c8ff62;\n  font-family: \"DM Mono\", monospace;\n  font-size: 8px;\n  letter-spacing: 0.08em;\n}\n\n.gh-design-ripple {\n  position: absolute;\n  z-index: 24;\n  width: 55px;\n  height: 55px;\n  border: 3px solid #c8ff62;\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n/* GlassHudVertical */\n.vh-glass {\n  border: 1px solid rgba(255, 255, 255, 0.26);\n  background: linear-gradient(145deg, rgba(255, 255, 255, 0.17), rgba(255, 255, 255, 0.055));\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.35),\n    0 30px 80px rgba(0, 0, 0, 0.28);\n  backdrop-filter: blur(28px) saturate(1.3);\n}\n\n.vh-photo-grade {\n  background:\n    radial-gradient(circle at 50% 38%, transparent, rgba(5, 8, 22, 0.25) 50%, rgba(5, 8, 22, 0.85)),\n    linear-gradient(180deg, rgba(5, 8, 22, 0.08), rgba(5, 8, 22, 0.72));\n}\n\n.vh-hud {\n  position: absolute;\n  z-index: 90;\n  inset: 0;\n  padding: 34px 34px 38px;\n  color: rgba(247, 248, 255, 0.72);\n  font-family: \"DM Mono\", monospace;\n  font-size: 13px;\n  letter-spacing: 0.12em;\n  pointer-events: none;\n}\n\n.vh-hud > div:first-child,\n.vh-hud > div:nth-child(3) {\n  display: flex;\n  justify-content: space-between;\n}\n\n.vh-hud > div:nth-child(3) {\n  position: absolute;\n  right: 34px;\n  bottom: 38px;\n  left: 34px;\n}\n\n.vh-hud-progress {\n  position: absolute;\n  right: 34px;\n  bottom: 74px;\n  left: 34px;\n  height: 2px;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.vh-hud-progress i {\n  display: block;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf, #c8ff62);\n  transform-origin: left center;\n}\n\n.vh-live {\n  color: #c8ff62;\n}\n\n.vh-live::before {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  margin-right: 9px;\n  content: \"\";\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 14px currentColor;\n}\n\n.vh-intro-ring {\n  position: absolute;\n  top: 520px;\n  left: 50%;\n  width: 620px;\n  height: 620px;\n  border-radius: 50%;\n}\n\n.vh-radar {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.vh-intro-ring::before,\n.vh-intro-ring::after {\n  position: absolute;\n  content: \"\";\n  border: 2px solid rgba(98, 231, 255, 0.5);\n  border-radius: 50%;\n}\n\n.vh-intro-ring::before {\n  inset: 65px;\n  border-style: dashed;\n}\n\n.vh-intro-ring::after {\n  inset: 130px;\n  border-color: rgba(255, 101, 191, 0.55);\n}\n\n.vh-intro-ring i {\n  position: absolute;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #62e7ff;\n  box-shadow: 0 0 32px #62e7ff;\n}\n\n.vh-intro-ring i:nth-child(1) {\n  top: 50%;\n  left: -17px;\n}\n\n.vh-intro-ring i:nth-child(2) {\n  top: -17px;\n  left: 50%;\n  background: #ff65bf;\n  box-shadow: 0 0 32px #ff65bf;\n}\n\n.vh-intro-ring i:nth-child(3) {\n  right: 30px;\n  bottom: 70px;\n  background: #c8ff62;\n  box-shadow: 0 0 32px #c8ff62;\n}\n\n.vh-vertical-scan {\n  position: absolute;\n  z-index: 4;\n  top: -300px;\n  left: 380px;\n  width: 190px;\n  height: 1750px;\n  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.26), rgba(255, 255, 255, 0.38), transparent);\n  filter: blur(30px);\n  mix-blend-mode: screen;\n}\n\n.vh-intro-copy {\n  position: absolute;\n  z-index: 6;\n  top: 865px;\n  left: 70px;\n}\n\n.vh-intro-copy > span,\n.vh-wave-copy > span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 15px;\n  letter-spacing: 0.14em;\n}\n\n.vh-intro-copy h1,\n.vh-cards-title,\n.vh-wave-copy h2 {\n  color: #f7f8ff;\n  margin: 38px 0 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 108px;\n  font-weight: 500;\n  line-height: 0.94;\n  letter-spacing: -0.065em;\n}\n\n.vh-intro-readouts {\n  position: absolute;\n  right: 65px;\n  bottom: 230px;\n  display: grid;\n  gap: 8px;\n  color: rgba(247, 248, 255, 0.54);\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n  letter-spacing: 0.12em;\n  text-align: right;\n}\n\n.vh-intro-copy h1 em,\n.vh-cards-title em,\n.vh-wave-copy h2 em {\n  color: #62e7ff;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 1.15em;\n  font-weight: 400;\n}\n\n.vh-data-pill {\n  position: absolute;\n  right: 64px;\n  bottom: 130px;\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 16px 40px;\n  width: 340px;\n  padding: 22px 26px;\n  border-radius: 24px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 13px;\n}\n\n.vh-data-pill strong {\n  color: #c8ff62;\n}\n\n.vh-data-pill i {\n  grid-column: 1 / -1;\n  height: 4px;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #5269ff, #62e7ff, #c8ff62);\n}\n\n.vh-scene-label {\n  position: absolute;\n  z-index: 10;\n  top: 85px;\n  left: 60px;\n  color: rgba(247, 248, 255, 0.66);\n  font-family: \"DM Mono\", monospace;\n  font-size: 14px;\n  letter-spacing: 0.14em;\n}\n\n.vh-cards-title {\n  position: absolute;\n  z-index: 5;\n  top: 220px;\n  left: 64px;\n  margin: 0;\n}\n\n.vh-cards-title em {\n  color: #ff65bf;\n}\n\n.vh-card-stack {\n  position: absolute;\n  z-index: 5;\n  top: 670px;\n  right: 55px;\n  left: 55px;\n  display: grid;\n  gap: 24px;\n}\n\n.vh-vertical-dock {\n  position: absolute;\n  z-index: 8;\n  right: 55px;\n  bottom: 92px;\n  left: 55px;\n  display: flex;\n  justify-content: center;\n  gap: 13px;\n  padding: 13px;\n  border-radius: 30px;\n}\n\n.vh-vertical-dock span {\n  display: grid;\n  width: 58px;\n  height: 58px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  border-radius: 19px;\n  background: rgba(255, 255, 255, 0.07);\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 22px;\n  place-items: center;\n}\n\n.vh-card {\n  position: relative;\n  height: 265px;\n  padding: 28px;\n  overflow: hidden;\n  border-radius: 42px;\n}\n\n.vh-card > div {\n  display: grid;\n  width: 74px;\n  height: 74px;\n  border: 1px solid currentColor;\n  border-radius: 25px;\n  font-size: 30px;\n  place-items: center;\n}\n\n.vh-card > span {\n  position: absolute;\n  bottom: 86px;\n  color: rgba(247, 248, 255, 0.55);\n  font-family: \"DM Mono\", monospace;\n  font-size: 12px;\n  letter-spacing: 0.12em;\n}\n\n.vh-card strong {\n  position: absolute;\n  bottom: 28px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 43px;\n  font-weight: 500;\n}\n\n.vh-card > i {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  width: 8px;\n  height: 100%;\n}\n\n.vh-waves {\n  position: absolute;\n  z-index: 3;\n  inset: 0;\n}\n\n.vh-wave-copy {\n  position: absolute;\n  z-index: 5;\n  right: 55px;\n  bottom: 280px;\n  left: 55px;\n  padding: 48px;\n  border-radius: 48px;\n}\n\n.vh-wave-copy h2 {\n  font-size: 104px;\n}\n\n.vh-wave-copy h2 em {\n  color: #ff65bf;\n}\n\n.vh-wave-arrow {\n  position: absolute;\n  z-index: 8;\n  top: 470px;\n  left: 80px;\n  display: grid;\n  width: 100px;\n  height: 100px;\n  color: #050816;\n  border-radius: 32px;\n  background: #c8ff62;\n  box-shadow: 0 0 48px rgba(200, 255, 98, 0.45);\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 50px;\n  place-items: center;\n}\n\n.vh-wave-readout {\n  position: absolute;\n  z-index: 8;\n  right: 60px;\n  top: 210px;\n  display: grid;\n  grid-template-columns: auto auto;\n  gap: 11px 25px;\n  padding: 20px 22px;\n  border-radius: 22px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n}\n\n.vh-wave-readout span {\n  color: rgba(247, 248, 255, 0.5);\n}\n\n.vh-wave-readout strong {\n  color: #62e7ff;\n  font-weight: 400;\n}\n\n.vh-flow-heading {\n  position: absolute;\n  z-index: 7;\n  top: 190px;\n  left: 58px;\n}\n\n.vh-flow-heading > span {\n  color: rgba(247, 248, 255, 0.58);\n  font-family: \"DM Mono\", monospace;\n  font-size: 12px;\n  letter-spacing: 0.14em;\n}\n\n.vh-flow-heading h2 {\n  margin: 28px 0 0;\n  color: #f7f8ff;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 82px;\n  font-weight: 500;\n  line-height: 0.95;\n  letter-spacing: -0.06em;\n}\n\n.vh-flow-heading h2 em {\n  color: #62e7ff;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 1.12em;\n  font-weight: 400;\n}\n\n.vh-flow-chamber {\n  position: absolute;\n  z-index: 6;\n  top: 510px;\n  right: 48px;\n  left: 48px;\n  height: 1040px;\n  overflow: hidden;\n  border-radius: 54px;\n  transform-origin: center;\n}\n\n.vh-flow-top {\n  position: absolute;\n  z-index: 3;\n  top: 28px;\n  right: 30px;\n  left: 30px;\n  display: flex;\n  justify-content: space-between;\n  color: rgba(247, 248, 255, 0.62);\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n  letter-spacing: 0.12em;\n}\n\n.vh-flow-top strong {\n  color: #c8ff62;\n  font-weight: 400;\n}\n\n.vh-flow-top i {\n  display: inline-block;\n  width: 7px;\n  height: 7px;\n  margin-left: 8px;\n  border-radius: 50%;\n  background: currentColor;\n  box-shadow: 0 0 12px currentColor;\n}\n\n.vh-flow-mesh {\n  position: absolute;\n  top: 70px;\n  left: 50%;\n  width: 880px;\n  height: 760px;\n  transform: translateX(-50%);\n}\n\n.vh-flow-meters {\n  position: absolute;\n  right: 30px;\n  bottom: 30px;\n  left: 30px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 14px;\n}\n\n.vh-flow-meters > div {\n  padding: 17px;\n  border: 1px solid rgba(255, 255, 255, 0.13);\n  border-radius: 19px;\n  background: rgba(5, 8, 22, 0.3);\n}\n\n.vh-flow-meters span,\n.vh-flow-meters strong {\n  display: block;\n  font-family: \"DM Mono\", monospace;\n}\n\n.vh-flow-meters span {\n  color: rgba(247, 248, 255, 0.42);\n  font-size: 8px;\n  letter-spacing: 0.1em;\n}\n\n.vh-flow-meters strong {\n  margin: 9px 0 13px;\n  color: #f7f8ff;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.vh-flow-meters i {\n  display: block;\n  height: 3px;\n  overflow: hidden;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.vh-flow-meters b {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(90deg, #62e7ff, #9c6cff, #ff65bf);\n  transform-origin: left center;\n}\n\n.vh-flow-sweep {\n  position: absolute;\n  z-index: 8;\n  top: -240px;\n  left: 350px;\n  width: 170px;\n  height: 1900px;\n  background: linear-gradient(90deg, transparent, rgba(98, 231, 255, 0.2), rgba(255, 255, 255, 0.34), transparent);\n  filter: blur(30px);\n  mix-blend-mode: screen;\n}\n\n.vh-flow-tags {\n  position: absolute;\n  z-index: 9;\n  right: 55px;\n  bottom: 150px;\n  left: 55px;\n  display: flex;\n  justify-content: center;\n  gap: 12px;\n}\n\n.vh-flow-tags span {\n  padding: 16px 20px;\n  border-radius: 999px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 9px;\n  letter-spacing: 0.11em;\n}\n\n.vh-workspace {\n  position: absolute;\n  z-index: 6;\n  top: 115px;\n  left: 55px;\n  width: 970px;\n  height: 1660px;\n  overflow: hidden;\n  border-radius: 44px;\n}\n\n.vh-workspace-top {\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  align-items: center;\n  height: 65px;\n  padding: 0 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  background: rgba(5, 8, 22, 0.58);\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n}\n\n.vh-workspace-top > div {\n  display: flex;\n  gap: 7px;\n}\n\n.vh-workspace-top i {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.vh-workspace-top i:first-child {\n  background: #ff7057;\n}\n\n.vh-workspace-top i:nth-child(2) {\n  background: #c8ff62;\n}\n\n.vh-workspace-top > span {\n  padding: 10px;\n  color: rgba(247, 248, 255, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  text-align: center;\n}\n\n.vh-workspace-top strong {\n  text-align: right;\n}\n\n.vh-toolbar {\n  position: absolute;\n  z-index: 5;\n  top: 85px;\n  left: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  width: 58px;\n  padding: 10px 7px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 20px;\n  background: rgba(5, 8, 22, 0.78);\n}\n\n.vh-toolbar span {\n  display: grid;\n  width: 42px;\n  height: 42px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 13px;\n  font-family: \"DM Mono\", monospace;\n  place-items: center;\n}\n\n.vh-toolbar > div {\n  width: 35px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.vh-toolbar > i {\n  width: 29px;\n  height: 29px;\n  border: 2px solid rgba(255, 255, 255, 0.22);\n  border-radius: 50%;\n}\n\n.vh-mobile-frame {\n  position: absolute;\n  top: 85px;\n  right: 56px;\n  bottom: 30px;\n  left: 94px;\n  overflow: hidden;\n  border-radius: 30px;\n  background: #f6f5f1;\n  box-shadow: 0 25px 70px rgba(0, 0, 0, 0.32);\n}\n\n.vh-site-scroll {\n  height: 2600px;\n  color: #111322;\n}\n\n.vh-site-hero {\n  height: 890px;\n  padding: 35px;\n}\n\n.vh-site-hero nav {\n  display: flex;\n  justify-content: space-between;\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n  letter-spacing: 0.08em;\n}\n\n.vh-site-kicker {\n  display: block;\n  margin-top: 72px;\n  color: #666b80;\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n  letter-spacing: 0.12em;\n}\n\n.vh-site-hero h2 {\n  min-height: 145px;\n  margin: 25px 0 12px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 61px;\n  line-height: 0.95;\n  letter-spacing: -0.06em;\n}\n\n.vh-site-hero h2 i {\n  display: inline-block;\n  width: 3px;\n  height: 54px;\n  margin-left: 5px;\n  vertical-align: -8px;\n  background: #5269ff;\n}\n\n.vh-site-hero p {\n  margin: 0;\n  color: #656a7c;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.vh-site-hero-image {\n  position: relative;\n  height: 390px;\n  margin-top: 35px;\n  overflow: hidden;\n  border-radius: 32px;\n}\n\n.vh-site-hero-image img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.vh-site-hero-image span {\n  position: absolute;\n  right: 15px;\n  bottom: 15px;\n  padding: 10px 13px;\n  color: #fff;\n  border-radius: 11px;\n  background: rgba(5, 8, 22, 0.65);\n  font-family: \"DM Mono\", monospace;\n  font-size: 9px;\n}\n\n.vh-site-services {\n  min-height: 710px;\n  padding: 50px 35px;\n  color: #f7f8ff;\n  background: #111322;\n}\n\n.vh-site-services > span,\n.vh-site-testimonial > span,\n.vh-site-footer > span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n  letter-spacing: 0.12em;\n}\n\n.vh-site-services h3 {\n  margin: 30px 0 35px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 51px;\n  line-height: 0.98;\n  letter-spacing: -0.055em;\n}\n\n.vh-site-services h3 em {\n  color: #62e7ff;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 1.1em;\n  font-weight: 400;\n}\n\n.vh-service-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.vh-service-grid article {\n  display: flex;\n  align-items: center;\n  height: 102px;\n  padding: 0 20px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 22px;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.vh-service-grid span {\n  color: #62e7ff;\n  font-family: \"DM Mono\", monospace;\n  font-size: 10px;\n}\n\n.vh-service-grid strong {\n  margin-left: 25px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 20px;\n}\n\n.vh-service-grid i {\n  margin-left: auto;\n  color: #c8ff62;\n  font-size: 22px;\n}\n\n.vh-site-testimonial {\n  min-height: 520px;\n  padding: 55px 35px;\n  background: #c8ff62;\n}\n\n.vh-site-testimonial blockquote {\n  margin: 48px 0;\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 45px;\n  line-height: 1.03;\n}\n\n.vh-site-testimonial > div {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 9px;\n}\n\n.vh-site-testimonial > div i {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #5269ff;\n}\n\n.vh-site-footer {\n  min-height: 550px;\n  padding: 55px 35px;\n  color: #f7f8ff;\n  background: linear-gradient(150deg, #5269ff, #9c6cff 55%, #ff65bf);\n}\n\n.vh-site-footer h3 {\n  margin: 55px 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 70px;\n  line-height: 0.9;\n  letter-spacing: -0.06em;\n}\n\n.vh-site-footer button {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 22px;\n  color: #111322;\n  border: 0;\n  border-radius: 18px;\n  background: #c8ff62;\n  font-family: \"DM Mono\", monospace;\n  font-size: 12px;\n}\n\n.vh-scrollbar {\n  position: absolute;\n  z-index: 5;\n  top: 100px;\n  right: 25px;\n  width: 4px;\n  height: 1310px;\n  overflow: hidden;\n  border-radius: 99px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.vh-scrollbar i {\n  display: block;\n  width: 100%;\n  height: 160px;\n  border-radius: inherit;\n  background: #62e7ff;\n  box-shadow: 0 0 12px #62e7ff;\n}\n\n.vh-selection {\n  position: absolute;\n  z-index: 15;\n  border: 2px solid;\n  pointer-events: none;\n}\n\n.vh-selection > span {\n  position: absolute;\n  top: -23px;\n  left: -2px;\n  padding: 4px 7px;\n  color: #050816;\n  background: currentColor;\n  font-family: \"DM Mono\", monospace;\n  font-size: 8px;\n}\n\n.vh-selection i {\n  position: absolute;\n  width: 9px;\n  height: 9px;\n  border: 2px solid currentColor;\n  background: #fff;\n}\n\n.vh-selection i:nth-of-type(1) {\n  top: -6px;\n  left: -6px;\n}\n\n.vh-selection i:nth-of-type(2) {\n  top: -6px;\n  right: -6px;\n}\n\n.vh-selection i:nth-of-type(3) {\n  bottom: -6px;\n  left: -6px;\n}\n\n.vh-selection i:nth-of-type(4) {\n  right: -6px;\n  bottom: -6px;\n}\n\n.vh-cursor {\n  position: absolute;\n  z-index: 30;\n  width: 44px;\n  transform-origin: 6px 6px;\n}\n\n.vh-cursor svg {\n  width: 44px;\n  filter: drop-shadow(0 6px 8px rgba(0, 0, 0, 0.35));\n}\n\n.vh-cursor span {\n  position: absolute;\n  top: 39px;\n  left: 24px;\n  padding: 5px 7px;\n  color: #050816;\n  border-radius: 6px;\n  background: #c8ff62;\n  font-family: \"DM Mono\", monospace;\n  font-size: 8px;\n}\n\n.vh-click {\n  position: absolute;\n  z-index: 29;\n  width: 55px;\n  height: 55px;\n  border: 3px solid #c8ff62;\n  border-radius: 50%;\n}\n\n.vh-dragged-service {\n  position: absolute;\n  z-index: 28;\n  display: flex;\n  align-items: center;\n  width: 360px;\n  height: 105px;\n  padding: 0 22px;\n  color: #f7f8ff;\n  border: 1px solid #62e7ff;\n  border-radius: 23px;\n  background: rgba(17, 19, 34, 0.92);\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.35);\n}\n\n.vh-dragged-service i {\n  color: #62e7ff;\n  font-family: \"DM Mono\", monospace;\n  font-size: 11px;\n}\n\n.vh-dragged-service strong {\n  margin-left: 24px;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 19px;\n}\n\n.vh-dragged-service span {\n  margin-left: auto;\n  color: #c8ff62;\n}\n\n.vh-vignette {\n  position: absolute;\n  z-index: 80;\n  inset: 0;\n  box-shadow: inset 0 0 150px rgba(0, 0, 0, 0.5);\n  pointer-events: none;\n}\n\n/* EditorialViralReel */\n.ev-paper {\n  color: #11110f;\n  background:\n    radial-gradient(circle at 50% 36%, rgba(255, 255, 255, 0.65), transparent 48%),\n    #e7e4dd;\n  overflow: hidden;\n}\n\n.ev-dark {\n  color: #f4f1ea;\n  background: #090909;\n  overflow: hidden;\n}\n\n.ev-grain {\n  position: absolute;\n  z-index: 90;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  mix-blend-mode: multiply;\n}\n\n.ev-intro-object {\n  position: absolute;\n  top: 540px;\n  left: 190px;\n  width: 700px;\n}\n\n.ev-bloom {\n  width: 100%;\n  overflow: visible;\n}\n\n.ev-bloom-compact {\n  width: 100%;\n}\n\n.ev-label {\n  position: absolute;\n  z-index: 5;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 49px;\n  font-weight: 600;\n  line-height: 0.98;\n  letter-spacing: -0.045em;\n}\n\n.ev-label-top {\n  top: 170px;\n  right: 70px;\n  text-align: right;\n}\n\n.ev-label-bottom {\n  bottom: 175px;\n  left: 64px;\n}\n\n.ev-label-bottom strong {\n  font-size: 64px;\n}\n\n.ev-arrow-top,\n.ev-arrow-bottom {\n  position: absolute;\n  color: #11110f;\n}\n\n.ev-arrow-top {\n  top: 250px;\n  left: 180px;\n  width: 320px;\n  transform: rotate(8deg);\n}\n\n.ev-arrow-bottom {\n  right: 130px;\n  bottom: 260px;\n  width: 300px;\n  transform: rotate(8deg);\n}\n\n.ev-curved-arrow {\n  width: 100%;\n}\n\n.ev-index {\n  position: absolute;\n  top: 58px;\n  left: 55px;\n  font-family: \"DM Mono\", monospace;\n  font-size: 13px;\n  letter-spacing: 0.16em;\n}\n\n.ev-portal {\n  position: absolute;\n  z-index: 2;\n  top: 49%;\n  left: 50%;\n  width: 680px;\n  height: 860px;\n  overflow: hidden;\n  clip-path: polygon(12% 0, 88% 0, 100% 10%, 100% 90%, 88% 100%, 12% 100%, 0 90%, 0 10%);\n  background: #181817;\n  box-shadow: 24px 35px 42px rgba(0, 0, 0, 0.3);\n}\n\n.ev-figure {\n  position: absolute;\n  right: 0;\n  bottom: -10px;\n  left: 0;\n  width: 100%;\n}\n\n.ev-panel {\n  position: absolute;\n  z-index: 4;\n  top: 530px;\n  width: 300px;\n  height: 850px;\n  overflow: hidden;\n  background: #181817;\n  box-shadow: 20px 25px 34px rgba(0, 0, 0, 0.26);\n}\n\n.ev-panel .ev-figure {\n  width: 680px;\n}\n\n.ev-panel-left {\n  left: 200px;\n  clip-path: polygon(22% 0, 100% 0, 100% 100%, 22% 100%, 0 90%, 0 10%);\n}\n\n.ev-panel-left .ev-figure {\n  left: 0;\n}\n\n.ev-panel-right {\n  right: 200px;\n  clip-path: polygon(0 0, 78% 0, 100% 10%, 100% 90%, 78% 100%, 0 100%);\n}\n\n.ev-panel-right .ev-figure {\n  right: 0;\n  left: auto;\n}\n\n.ev-panel-bloom {\n  position: absolute;\n  z-index: 6;\n  top: 54%;\n  left: 50%;\n  width: 500px;\n}\n\n.ev-split-lines i {\n  position: absolute;\n  z-index: 7;\n  top: 730px;\n  width: 2px;\n  height: 710px;\n  background: rgba(17, 17, 15, 0.45);\n}\n\n.ev-split-lines i:first-child {\n  left: 175px;\n  transform: rotate(38deg);\n}\n\n.ev-split-lines i:last-child {\n  right: 175px;\n  transform: rotate(-38deg);\n}\n\n.ev-panel-copy {\n  position: absolute;\n  z-index: 8;\n  top: 270px;\n  left: 60px;\n}\n\n.ev-panel-copy span,\n.ev-lens-copy span,\n.ev-stage-copy span,\n.ev-system-copy span {\n  font-family: \"DM Mono\", monospace;\n  font-size: 13px;\n  letter-spacing: 0.13em;\n}\n\n.ev-panel-copy h2 {\n  min-height: 110px;\n  margin: 20px 0 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 78px;\n  line-height: 0.95;\n  letter-spacing: -0.06em;\n}\n\n.ev-panel-copy h2 i {\n  display: inline-block;\n  width: 4px;\n  height: 72px;\n  margin-left: 5px;\n  vertical-align: -10px;\n  background: #d64a3a;\n}\n\n.ev-lens-wrap {\n  position: absolute;\n  top: 51%;\n  left: 50%;\n  width: 680px;\n}\n\n.ev-lens-orb {\n  width: 100%;\n  overflow: visible;\n}\n\n.ev-analysis-lines {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.ev-lens-copy {\n  position: absolute;\n  top: 185px;\n  left: 58px;\n}\n\n.ev-lens-copy h2 {\n  margin: 25px 0 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 74px;\n  line-height: 0.94;\n  letter-spacing: -0.055em;\n}\n\n.ev-lens-copy h2 em {\n  font-family: \"Instrument Serif\", Georgia, serif;\n  font-size: 1.15em;\n  font-weight: 400;\n}\n\n.ev-dark-camera {\n  position: absolute;\n  inset: 0;\n  transform-origin: center 56%;\n}\n\n.ev-light-pool {\n  position: absolute;\n  z-index: 2;\n  top: 48%;\n  left: 50%;\n  width: 620px;\n  height: 620px;\n  border-radius: 50%;\n  background: #e7e4dd;\n  transform: translate(-50%, -50%);\n  box-shadow: 0 0 100px rgba(244, 241, 234, 0.2);\n}\n\n.ev-stage-bloom {\n  position: absolute;\n  z-index: 5;\n  top: 48%;\n  left: 50%;\n  width: 430px;\n}\n\n.ev-spotlights {\n  position: absolute;\n  z-index: 4;\n  top: 48%;\n  left: 50%;\n}\n\n.ev-spotlight {\n  position: absolute;\n  bottom: -30px;\n  left: 50%;\n  clip-path: polygon(50% 100%, 0 0, 100% 0);\n  background: linear-gradient(180deg, rgba(244, 241, 234, 0.04), rgba(244, 241, 234, 0.92));\n  transform-origin: 50% 100%;\n  mix-blend-mode: screen;\n}\n\n.ev-stage-copy {\n  position: absolute;\n  z-index: 10;\n  top: 180px;\n  left: 55px;\n}\n\n.ev-stage-copy h2,\n.ev-system-copy h2 {\n  margin: 22px 0 0;\n  font-family: \"Manrope\", Arial, sans-serif;\n  font-size: 70px;\n  font-weight: 400;\n  line-height: 0.92;\n  letter-spacing: -0.055em;\n}\n\n.ev-stage-copy h2 strong,\n.ev-system-copy h2 strong {\n  font-size: 92px;\n}\n\n.ev-system-camera {\n  position: absolute;\n  top: 54%;\n  left: -60px;\n  width: 1700px;\n  height: 960px;\n  transform-origin: 540px 440px;\n}\n\n.ev-system-line {\n  position: absolute;\n  top: 440px;\n  left: 0;\n  width: 1680px;\n  height: 4px;\n  background: #e7e4dd;\n  opacity: 0.7;\n}\n\n.ev-system-node {\n  position: absolute;\n  z-index: 4;\n  top: 440px;\n  width: 230px;\n  height: 230px;\n}\n\n.ev-node-disc {\n  position: absolute;\n  z-index: 3;\n  inset: 0;\n  display: grid;\n  border-radius: 50%;\n  background: #e7e4dd;\n  box-shadow: 0 0 55px rgba(244, 241, 234, 0.14);\n  place-items: center;\n}\n\n.ev-node-disc .ev-bloom {\n  width: 155px;\n}\n\n.ev-node-light {\n  position: absolute;\n  z-index: 2;\n  bottom: 115px;\n  left: 50%;\n  width: 150px;\n  height: 620px;\n  clip-path: polygon(50% 100%, 0 0, 100% 0);\n  background: linear-gradient(180deg, rgba(244, 241, 234, 0.92), rgba(244, 241, 234, 0.03));\n  transform-origin: 50% 100%;\n}\n\n.ev-system-frames i {\n  position: absolute;\n  top: 655px;\n  width: 190px;\n  height: 260px;\n  border: 3px solid rgba(231, 228, 221, 0.18);\n  transform: translateX(-50%);\n}\n\n.ev-system-frames i::after {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 86px;\n  height: 86px;\n  content: \"\";\n  border: 2px solid rgba(231, 228, 221, 0.2);\n  transform: translate(-50%, -50%);\n}\n\n.ev-system-copy {\n  position: absolute;\n  z-index: 10;\n  top: 145px;\n  left: 55px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
